<template>
  <div class="editor-main-inside">
    <TableHeader />
    <!-- @scroll="handleScroll" -->
    <div id="editorBox" ref="editorBox" class="content-area-wrap" @contextmenu.prevent="handleOpenMenu($event)">
      <el-row class="content-area" v-for="(item, index) in getList" :key="item.id" :class="{
        'last-content': getList.length === index + 1,
        'active-section': parseInt(item.id) === parseInt(currentId),
      }" :infoId="item.id" :uid="item.transUserId" :id="`content-${item.id}`">
        <el-col class="order" :span="1">
          <span class="inside">
            {{ getinside(getTaskContentListParams.startSort, index) }}
          </span>
        </el-col>
        <el-col :span="10" type="source" v-if="componentsState" class="source editor"
          :class="`font-${getEditorFontSizeInfo} `">
          <div class="df" :id="'source-df' + item.id"></div>
          <ContenteditableHTML :flag="flag" :isOpenQa="isOpenQa" :isPreMts="isPreMt" type="source" :itemInfos="item"
            :editorMode="editorMode" :ref="`source-${item.id}`" :id="`source-${item.id}`"
            :contenteditable="getSourceEditorState(item, 'source', true)" :fragmentIndex="index + 1"
            :info="getInfo(item, 'source')" @click.native="(e) => handleEditor(e, item, 'source')"
            @mouseup.native="(e) => handleMouseup(e, item, 'source')" @focus.native="(e) => toggleFlag(e, item, 'source')"
            @blur.native="(e) => handleBlur(e, item, 'source', index)"
            @keyup.native="(e) => handleKeyupSource(e, item, index, 'source')"
            @keydown.native="(e) => handleKeyup(e, item, 'source', index)"
            @input.native="(e) => handleInput(e, item, 'source')"
            @mousedown.native="(e) => handleMousedown(e, 'source')" />
        </el-col>
        <el-col :span="11" type="target" v-if="componentsState" class="target editor"
          :class="`font-${getEditorFontSizeInfo} ${getisContent(item.id)} `">
          <div class="df" ref="df" :id="'target-df' + item.id"></div>
          <ContenteditableTargetHTML :flag="flag" :isPreMts="isPreMt" type="target" :itemInfos="item"
            :editorMode="editorMode" :ref="`target-${item.id}`" :id="`target-${item.id}`"
            :contenteditable="getTargetEditorState(item, 'target', true)" :fragmentIndex="index + 1"
            :info="getInfo(item, 'target')" @click.native="(e) => handleEditor(e, item, 'target')"
            @mouseup.native="(e) => handleMouseup(e, item, 'target')"
            @mousedown.native="(e) => handleMousedown(e, 'target')"
            @blur.native="(e) => handleBlur(e, item, 'target', index)"
            @focus.native="(e) => toggleFlag(e, item, 'target')"
            @keyup.native="(e) => handleKeyupSource(e, item, index, 'target')"
            @keydown.native="(e) => handleKeyup(e, item, 'target', index, 'enter')"
            @input.native="(e) => handleInput(e, item, 'target')" @paste.native="(e) => handlePaste(e, item)"
            @compositionend.native="(e) => handleCompositionend(e, item)" />
        </el-col>
        <el-col class="condition" :span="1">
          <!-- 项目进入：句子是编辑还是锁定 -->
          <template v-if="getUrlInfo.type === 'project'">
            <div class="modification inside" :class="lockState(item) ? 'editor' : 'locking'"
              :title="lockState(item) ? '状态-编辑' : '状态-锁死'" @contextmenu.prevent.stop="handleOpenLockMenu($event, item)" />
          </template>
          <!-- 任务进入： -->
          <template v-if="getUrlInfo.type === 'task' || getUrlInfo.type === 'school'">
            <!-- 不锁定 -->
            <div class="task-state" v-if="lockState(item)">
              <!-- 有机器翻译 -->
              <template v-if="isPreMt">
                <div class="state-left-box" :title="getTaskState(item).title" typeInfo="confirm-state"
                  :class="getTaskState(item).className" @click="handleUpdataState(item)"></div>
                <div class="state-right-box">
                  <div class="right-icon" :class="getMachineTranslatedState(item)"
                    v-if="haveAT && isPreMt && item.similarPercent === 0" />
                  <!-- 挂载记忆库显示百分比 -->
                  <div class="similarPercent" v-else>
                    {{ item.similarPercent }}%
                  </div>
                  <template v-if="getFragmentQA(item)">
                    <el-popover placement="right" width="150" trigger="click" class="qa-popover"
                      popper-class="custom-popover-style">
                      <p v-for="QAItem in itemQAList" :key="QAItem.id" class="qa-item">{{ QAItem.description }}</p>
                      <el-button slot="reference">
                        <!-- <div class="right-icon" :class="{ 'QA-error': getFragmentQA(item) }" @click="changeQA(item)"></div> -->
                        <div class="right-icon" :class="{ 'QA-error': getFragmentQA(item) }" @click="showQAList(item)">
                        </div>
                      </el-button>
                    </el-popover>
                  </template>
                </div>
              </template>
              <!-- 没有机器翻译 -->
              <template v-else>
                <div class="state-left-box" :title="getTaskState(item).title" typeInfo="confirm-state"
                  :class="getTaskState(item).className" @click="handleUpdataState(item)"></div>
                <!-- 是否挂载记忆库 -->
                <div class="state-right-box" v-if="getProjectInfo.isUseMemory && item.similarPercent != 0">
                  <!-- 挂载记忆库显示百分比 -->
                  <div class="similarPercent">{{ item.similarPercent }}%</div>
                </div>
              </template>
            </div>
            <!-- 锁定 -->
            <div class="task-state" v-else>
              <div title="状态-锁死" class="state-left-box locking"
                @contextmenu.prevent.stop="handleOpenLockMenu($event, item)"></div>
            </div>
          </template>
        </el-col>
        <template>
          <el-col class="annotation" :span="1" v-if="parseInt(item.remarkStatus) === 0">
            <span class="inside" title="备注" @click="handleRemarks(item)" />
          </el-col>
          <el-col class="annotation" :span="1" v-if="parseInt(item.remarkStatus) === 1">
            <span class="inside annotation-finish" title="备注" @click="handleGetRemarks(item, item.remarkStatus)" />
          </el-col>
        </template>
      </el-row>
    </div>
    <div class="pagination">
      <div class="page-item">
        <span> 当前页数</span>
        <i class="el-icon-arrow-left"></i>
        <span>{{ getTaskContentListParams.startSort }} /
          {{ getTaskContentList.totalPage }}</span>
        <i class="el-icon-arrow-right"></i>
        <el-input v-model.number="page" size="small" @change="changegoPage">
        </el-input>
        <el-button type="info" size="mini" @click="gotopage"> 跳 </el-button>
      </div>
      <div class="page-btn">
        <el-button type="primary" size="mini" v-show="getTaskContentListParams.startSort > 1" @click="handlerPrev">
          上一页
        </el-button>
        <el-button type="primary" size="mini" @click="handlerNext" v-show="!(
          getTaskContentListParams.startSort >= getTaskContentList.totalPage
        )
          ">
          下一页</el-button>
      </div>
    </div>
    <!--鼠标右键-->
    <MouseRight :mouseInfo="mouseInfo" @handleCloseMenu="handleCloseMenu" @handleRemarks="handleRemarks"
      @reviseBtn="reviseBtn" />
    <!--备注的弹出-->
    <Remarks :shown="visibleRemarks" :remarkInfo="remarkInfo" type="add" @handleCancel="handleCancel" />
    <!--QA检测弹出-->
    <ExaminationQA :shown="examinationQA" :targetStr="targetStr" @handleCancel="handleCancel" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import MouseRight from "./modules/mouseRight";
import _ from "lodash";
import TableHeader from "./modules/tableHeader";
import Remarks from "@/components/layer/remarks";
import ExaminationQA from "@/components/layer/examinationQA";
import ContenteditableHTML from "./modules/contenteditableHTML";
import { eventUtil } from "@/components/editor/modules/eventUtil";
import ContenteditableTargetHTML from "./modules/contenteditableTargetHTML";
import {
  setCursorEnd,
  domArray,
  domArray2,
  trimSpace,
  saveSelection,
  restoreSelection,
} from "@/services/common";
import moment from "moment";
import { processSentRevisionTraces, sendMsg } from "@/services/editorApi";

export default {
  name: "EditorMain",
  components: {
    MouseRight,
    Remarks,
    ExaminationQA,
    TableHeader,
    ContenteditableHTML,
    ContenteditableTargetHTML,
  },
  props: ["editorMode"],
  data() {
    return {
      haveAT: haveAT,
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      type: "source",
      rang: null,
      startRange: null,
      endRange: null,
      insertDomList: [],
      range: null,
      typeInfo: null,
      currentId: null,
      currentIdType: null,
      targetStr: "",
      updataType: "blur",
      clickInfo: {},
      mouseInfo: {},
      remarkInfo: {},
      examinationQA: false,
      visibleRemarks: false,
      componentsState: true,
      oldtimeStamp: 0,
      flag: false,
      clientY: "",
      clientX: "",
      contentEditableValue: "true", //plaintext-only
      selectOldData: "", //存储光标选择的文本
      flagId: "",
      sourceKeyword: "", //原文光标选中文字
      targetKeyword: "", //译文光标选中文字
      getTaskDetailNum: 0, //调取任务详情接口次数
      urlInfo: JSON.parse(this.$Base64.decode(this.$route.query.key)) || {},
      isupdateStatus: 0,
      page: 1,
      totalPage: null,
      reviseDom: null,
      isRevise: false,
      info: [], //存储当前的选择的数据
      costTime: null,
      ctrlPressed: false, //键盘Ctrl是否按下
      isScollerView: false, //是否滚动元素到视口
      itemQAList: [],//句子的QA
      editTimer: null,
      enterFoucs: true, //回车聚焦
      mousedownType: '',//鼠标按下的类型
      isChangeModifyingRecords: 1, //是否添加修改记录
    };
  },

  watch: {
    getTaskContentListParams: {
      handler(value) {
        if (value.isfilter) {
          this.page = 1;
        }
      },
      deep: true,
    },
    editorMode(value, value2) {
      if (value !== value2) {
        this.$forceUpdate();
      }
    },
    webSocketMessage(newVal) {
      if (newVal.type == "transInput") {
        // console.log(newVal.data, '@@#$$');
        //如果是项目经理从项目进入
        let isPM = this.getUserInfo.id == this.getProjectInfo.creatorId; //项目经理
        let type = this.getUrlInfo.type
        if (type == 'project' && isPM) {
          let item = this.getList.find(item => item.id == newVal.data.sentId)
          if (newVal.data.editType == 'target') {
            let tagTargetSent = JSON.parse(item.tagTargetSent)
            tagTargetSent.fragments[0].atoms[0].data = newVal.data.sentContext
            item.tagTargetSent = JSON.stringify(tagTargetSent)
          } else if (newVal.data.editType == 'source') {
            let tagSourceSent = JSON.parse(item.tagSourceSent)
            tagSourceSent.fragments[0].atoms[0].data = newVal.data.sentContext
            item.tagSourceSent = JSON.stringify(tagSourceSent)
          }
          item.operatorName = newVal.data.userName ? newVal.data.userName : null
          item.operatorId = newVal.data.userId
          item.editType = newVal.data.editType
          //更新句子
          // console.log(item);
          this.UPDATE_transSentRespVoList_ITEM(item)
          // console.log('项目经理收到消息：', newVal.data.sentContext,JSON.parse(this.getList.find(item=>item.id == newVal.data.sentId).tagTargetSent).fragments[0].atoms[0].data);
          // 开始计时
          this.startEditTimer(item);
        }
      } else if (newVal.type == "adminTransInput") {
        // console.log(newVal.data, '@@#$$');
        //译员从任务进去
        let type = this.getUrlInfo.type
        if (type == 'task') {
          let item = this.getList.find(item => item.id == newVal.data.sentId)
          if (newVal.data.editType == 'target') {
            let tagTargetSent = JSON.parse(item.tagTargetSent)
            tagTargetSent.fragments[0].atoms[0].data = newVal.data.sentContext
            item.tagTargetSent = JSON.stringify(tagTargetSent)
          } else if (newVal.data.editType == 'source') {
            let tagSourceSent = JSON.parse(item.tagSourceSent)
            tagSourceSent.fragments[0].atoms[0].data = newVal.data.sentContext
            item.tagSourceSent = JSON.stringify(tagSourceSent)
          }
          item.operatorName = newVal.data.userName ? newVal.data.userName : null
          item.operatorId = newVal.data.userId
          item.editType = newVal.data.editType
          //更新句子
          // console.log(item);
          this.UPDATE_transSentRespVoList_ITEM(item)

          this.startEditTimer(item);
        }
      }
    }
  },

  computed: {
    ...mapGetters("editor", [
      "getPartIndex", // 获取预览页码
      "getProjectInfo", // 获取项目信息
      "getUserInfo", // 获取当前用户的信息
      "getUrlInfo", // 路由参数
      "getisSourceedit", // 编辑原文状态
      "getEditorFontSizeInfo", // 获取当前字体大小
      "getQAList", // 获取QA列表
      "getFileInfo", // 文件信息
      "getFileTaskInfo", // 文件任务信息
      "getTaskContentList", // 获取编辑器文件list ( 文件内容列表 )
      "getSourceeditStatus", // 获取句子原文的编辑状态
      "getTargeteditStatus", // 获取句子译文的编辑状态
      "getTaskContentListParams",
    ]),
    ...mapState('ws', ['webSocketMessage']),
    /**
     * @desc 是否开启机翻
     * @return {boolean}
     */
    isPreMt() {
      const { isPreMt } = this.getProjectInfo;
      // 0关闭 1开启
      return isPreMt ? true : false;
    },
    /**
     * @desc 是否开启QA
     * @return {boolean}
     */
    isOpenQa() {
      const { isOpenQa } = this.getProjectInfo;
      // 0关闭 1开启
      return isOpenQa ? true : false;
    },
    //获取片段QA信息
    getFragmentQA() {
      return function (row) {
        let state = false;
        if (!!this.getQAList && !!this.getQAList.length) {
          this.getQAList.every((item) => {
            if (parseInt(item.transFileSentId) === parseInt(row.id)) {
              state = true;
              return false;
            } else {
              state = false;
              return true;
            }
          });
        }
        return state;
      };
    },
    //不使用辅助函数的获取数据-获取文件解析的文本
    getList() {
      if (
        this.getTaskContentList &&
        this.getTaskContentList.transSentRespVoList
      ) {
        return this.getTaskContentList.transSentRespVoList;
      } else {
        return [];
      }
    },
    // 编辑器右键功能
    getEditorRightShownInfo() {
      const self = this;
      let editorShownInfo =
        self.$store.getters["editor/getEditorRightShownInfo"];
      self.form = {
        source: editorShownInfo.sourceKeyword,
        target: editorShownInfo.targetKeyword,
      };
      return editorShownInfo;
    },
    getcountTargetIsnullIdList() {
      return this.$store.getters["editor/getcountTargetIsnullIdList"];
    },
  },
  created() {
    this.checkBrowser();
  },
  mounted() {
    this.$nextTick(() => {
      // 页面注册滚动事件   去除滚动事件
      // document.addEventListener('scroll', this.handleScroll);
      // 点击确认句子
      document.addEventListener("mousedown", this.handleClickUpdataState);
      document.body.addEventListener("click", this.handleCloseMenu);
      document.addEventListener("mouseup", this.setTerm);
    });
    this.totalPage = this.getTaskContentList.totalPage;
  },

  destroyed() {
    // 页面注册滚动事件
    // document.removeEventListener('scroll', this.handleScroll);
    // 点击确认句子
    document.removeEventListener("mousedown", this.handleClickUpdataState);
    document.body.removeEventListener("click", this.handleCloseMenu);
    document.removeEventListener("mouseup", this.setTerm);
  },

  methods: {
    ...mapActions('ws', ['WEBSOCKET_MESSAGE']),
    ...mapMutations('editor', ['UPDATE_transSentRespVoList_ITEM']),
    startEditTimer(item) {
      // 停止之前的计时器
      this.stopEditTimer();

      // 开始新的计时器
      this.editTimer = setTimeout(() => {
        item.editType = '';
        item.operatorName = null;
        item.operatorId = null;
        this.UPDATE_transSentRespVoList_ITEM(item);
      }, 120000); // 2分钟后触发计时器
    },
    stopEditTimer() {
      // 停止之前的计时器
      if (this.editTimer) {
        clearTimeout(this.editTimer);
        this.editTimer = null;
      }
    },
    //修订
    async reviseBtn(bool) {
      // console.log(
      //   bool,
      //   this.reviseDom,
      //   this.currentIdType,
      //   this.getFileInfo,
      //   this.getUrlInfo
      // );
      let parentDom = this.reviseDom.parentNode;
      // console.log(parentDom);
      let reviseDomList = [];
      let selectDomIndex = null;
      let stop = false;
      parentDom.childNodes.forEach((element, index) => {
        if (element === this.reviseDom) {
          selectDomIndex = index;
        }
        if (element.className === this.reviseDom.className && stop === false) {
          //当前元素classname==选中的classname
          reviseDomList.push(element);
        } else {
          if (selectDomIndex === null) {
            reviseDomList = [];
          } else if (selectDomIndex !== null && index > selectDomIndex) {
            stop = true;
          }
        }
      });
      // console.log(reviseDomList);
      reviseDomList.forEach((element) => {
        if (bool) {
          if (element.className.includes("insert")) {
            element.className = "equal";
          } else {
            element.innerHTML = "";
          }
        } else {
          if (element.className.includes("del")) {
            element.className = "equal";
          } else {
            element.innerHTML = "";
          }
        }
      });
      let sentContent = "";
      let childrenNodeAll = [];
      parentDom.childNodes.forEach((element) => {
        if (bool) {
          //接受修订
          console.log("接受修订", reviseDomList.includes(element), element);
          if (reviseDomList.includes(element)) {
            if (
              element.className.includes("equal") ||
              element.className.includes("tag-img") ||
              element.className.includes("insert")
            ) {
              sentContent += element.outerText;
              childrenNodeAll.push(element);
            }
          } else {
            if (
              element.className.includes("equal") ||
              element.className.includes("tag-img") ||
              element.className.includes("del")
            ) {
              sentContent += element.outerText;
              // if (element.className.includes('del')) {
              //   element.className = 'equal'
              // }
              childrenNodeAll.push(element);
            }
          }
        } else {
          //拒绝修订
          console.log("拒绝修订");
          if (
            element.className.includes("equal") ||
            element.className.includes("tag-img") ||
            element.className.includes("del")
          ) {
            sentContent += element.outerText;
            childrenNodeAll.push(element);
          }
        }
      });
      let row = null;
      let rowIndex = null;
      let fileId = null;
      this.getList.forEach((element, index) => {
        if (element.id === Number(this.currentIdType.split("-")[1])) {
          row = element;
          rowIndex = index;
          fileId = element.transFileId;
          // console.log(element, 22222);
        }
      });
      let targetTagFragmentVo = domArray(childrenNodeAll, row, []);
      let body = {
        projectId: this.getUrlInfo.projectId,
        sentContent: sentContent,
        fileId: fileId,
        targetTagFragmentVo: {
          atoms: targetTagFragmentVo,
        },
        sentId: this.currentIdType.split("-")[1],
      };
      // console.log(body);
      const { success, result } = await processSentRevisionTraces(body);
      this.isRevise = false;
      if (success) {
        this.handleBlur({ target: parentDom }, row, "target", rowIndex, true);
        // const { type, fileId, taskType } = this.getUrlInfo
        // const marker = type === 'project' ? 2 : 1
        // const params = {
        //   ...this.getTaskContentListParams,
        //   marker,
        //   comparedHighlight: 0,
        //   showTerm: 1,
        //   transFileId: fileId,
        //   taskType: taskType || 1,
        //   // transModel: 0
        // }
        // this.$store.dispatch('editor/getTaskContent', params)
      }
    },
    //中文输入事件
    handleCompositionend(e) {
      console.log("handleCompositionend", e);
      this.endRange = saveSelection();
      //获取要操作的dom元素
      let dom = e.target;
      if (this.editorMode !== "mark") {
        return;
      }
      if (!this.startRange.delStr && e.data.length > 0) {
        //点击输入
        // console.log("点击输入");
        if (
          !this.endRange.commonAncestorContainer.parentNode.className.includes(
            "insert"
          )
        ) {
          let insertInsertDom = document.createElement("span");
          insertInsertDom.innerHTML = e.data;
          insertInsertDom.setAttribute("class", "insert");
          let leftDom = null;
          let rightDom = null;
          if (
            this.startRange.startContainer.className ===
            this.startRange.endContainer.className &&
            this.startRange.startContainer.data === undefined
          ) {
            console.log("当前方是特殊标签时");
            if (this.endRange.commonAncestorContainer.parentNode === e.target) {
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.nextElementSibling
              );
              dom.removeChild(this.endRange.commonAncestorContainer);
              this.setRangeIndex(
                insertInsertDom.childNodes[0],
                insertInsertDom.childNodes[0].length
              );
            } else {
              console.log("重复删除输入");
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.parentNode.parentNode
                  .nextElementSibling
              );
              dom.removeChild(
                this.endRange.commonAncestorContainer.parentNode.parentNode
              );
              this.setRangeIndex(
                insertInsertDom.childNodes[0],
                insertInsertDom.childNodes[0].length
              );
            }
            return;
          } else if (
            this.endRange.endOffset === this.endRange.endContainer.length
          ) {
            //在最后输入添加
            console.log("在最后输入添加");
            leftDom = document.createElement("span");
            leftDom.innerHTML = this.endRange.endContainer.data.slice(
              0,
              this.endRange.endOffset - e.data.length
            );
            leftDom.setAttribute(
              "class",
              this.endRange.endContainer.parentNode.className
            );
            if (this.endRange.commonAncestorContainer.data === e.data) {
              //重复删除输入
              console.log("重复删除输入", leftDom, insertInsertDom, rightDom);
              if (
                this.endRange.commonAncestorContainer.parentNode === e.target
              ) {
                console.log("特殊标记前的重复输入");
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.childNodes[0]
                );
                console.log(this.endRange.commonAncestorContainer);
                this.endRange.commonAncestorContainer.parentNode.removeChild(
                  this.endRange.commonAncestorContainer
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
                return;
              }
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.parentNode.parentNode
                  .nextElementSibling
              );
              this.endRange.commonAncestorContainer.parentNode.parentNode.removeChild(
                this.endRange.commonAncestorContainer.parentNode
              );
              this.setRangeIndex(
                insertInsertDom.childNodes[0],
                insertInsertDom.childNodes[0].length
              );
              return;
            }
          } else if (this.endRange.endOffset > 1) {
            //在中间添加
            console.log("在中间添加");
            leftDom = document.createElement("span");
            leftDom.innerHTML = this.endRange.endContainer.data.slice(
              0,
              this.endRange.endOffset - e.data.length
            );
            leftDom.setAttribute(
              "class",
              this.endRange.endContainer.parentNode.className
            );
            rightDom = document.createElement("span");
            rightDom.innerHTML = this.endRange.endContainer.data.slice(
              this.endRange.endOffset
            );
            rightDom.setAttribute(
              "class",
              this.endRange.endContainer.parentNode.className
            );
          } else {
            //在开头添加
            console.log("在开头添加");
            rightDom = document.createElement("span");
            rightDom.innerHTML = this.endRange.endContainer.data.slice(
              this.endRange.endOffset
            );
            rightDom.setAttribute(
              "class",
              this.endRange.endContainer.parentNode.className
            );
          }
          // console.log(leftDom, insertInsertDom, rightDom);
          rightDom &&
            dom.insertBefore(
              rightDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
          dom.insertBefore(
            insertInsertDom,
            this.endRange.commonAncestorContainer.parentNode.nextElementSibling
          );
          leftDom &&
            dom.insertBefore(
              leftDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
          dom.removeChild(this.endRange.commonAncestorContainer.parentNode);
          this.setRangeIndex(
            insertInsertDom.childNodes[0],
            insertInsertDom.childNodes[0].length
          );
        } else {
          //在新增中输入
        }
      } else {
        //划词输入
        console.log("划词输入");
        let insertInsertDom = document.createElement("span");
        insertInsertDom.innerHTML = e.data;
        insertInsertDom.setAttribute("class", "insert");
        let insertDelDom = document.createElement("span");
        insertDelDom.innerHTML = this.startRange.delStr;
        insertDelDom.setAttribute("class", "del");
        if (this.endRange.endContainer.length === this.endRange.endOffset) {
          console.log("当光标所处位置的前一个元素为一个单元整体时");
          dom.insertBefore(
            insertDelDom,
            this.endRange.commonAncestorContainer.parentNode.nextElementSibling
          );
          if (!this.startRange.startContainer.className.includes("insert")) {
            dom.insertBefore(
              insertInsertDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
          }
        } else if (
          this.endRange.startContainer === this.endRange.endContainer &&
          this.endRange.endOffset === 0
        ) {
          console.log("最前方已没有数据");
          dom.insertBefore(
            insertDelDom,
            this.endRange.commonAncestorContainer.parentNode
          );
          dom.insertBefore(
            insertInsertDom,
            this.endRange.commonAncestorContainer.parentNode
          );
        } else if (
          this.endRange.startContainer === this.endRange.endContainer &&
          this.endRange.endContainer === e.target
        ) {
          //当前方是特殊标签时
          console.log("当前方是特殊标签时");
          dom.insertBefore(
            insertDelDom,
            this.endRange.commonAncestorContainer.childNodes[
            this.endRange.endOffset
            ]
          );
          dom.insertBefore(
            insertInsertDom,
            this.endRange.commonAncestorContainer.childNodes[
            this.endRange.endOffset
            ]
          );
        } else {
          //从中间划词删
          console.log("从中间划词删并添加输入文字");
          if (!this.startRange.startContainer.className.includes("insert")) {
            let leftDom = document.createElement("span");
            leftDom.innerHTML = this.endRange.startContainer.data.slice(
              0,
              this.startRange.startOffset
            );
            leftDom.setAttribute(
              "class",
              this.endRange.startContainer.parentNode.className
            );
            let rightDom = document.createElement("span");
            rightDom.innerHTML = this.endRange.endContainer.data.slice(
              this.endRange.endOffset
            );
            rightDom.setAttribute(
              "class",
              this.endRange.endContainer.parentNode.className
            );
            dom.insertBefore(
              rightDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
            dom.insertBefore(
              insertDelDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
            dom.insertBefore(
              insertInsertDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
            dom.insertBefore(
              leftDom,
              this.endRange.commonAncestorContainer.parentNode
                .nextElementSibling
            );
            dom.removeChild(this.endRange.commonAncestorContainer.parentNode);
            this.setRangeIndex(
              insertInsertDom.childNodes[0],
              insertInsertDom.childNodes[0].length
            );
          }
        }
      }
    },
    //输入input事件
    handleInput(e, item, type) {
      console.log(type);
      //发送websocket
      {
        const { type: fromType } = this.getUrlInfo
        if (fromType == 'task') {
          let innerText = trimSpace(e.target.innerText);
          const { projectId, fileId, companyCode } = this.getFileTaskInfo
          let params = {
            type: 'editTransFileSent',
            companyCode,                      //公司编码
            projectId,                        //项目id
            fileId,                           //文件id
            userId: this.getUserInfo.id,      //用户id
            sentId: item.id,                  //句子id
            userName: this.getUserInfo.nickName,   //用户名字
            // index: selection.focusOffset,      //光标位置
            sentContext: innerText,           //文本内容
            editType: type,                   //编辑的是原文还是译文
            optType: 1,                       //操作类型
            isEdit: 1,                        //正在编辑 1 编辑完成0
          }
          //发送消息
          this.WEBSOCKET_MESSAGE(params)
        } else if (fromType == 'project') {
          let innerText = trimSpace(e.target.innerText);
          const { projectId, id: fileId, companyCode } = this.getFileInfo
          let params = {
            type: 'adminEditTransFileSent',
            companyCode,                      //公司编码
            projectId,                        //项目id
            fileId,                           //文件id
            userId: this.getUserInfo.id,      //用户id
            sentId: item.id,                  //句子id
            userName: '项目经理',   //用户名字
            // index: selection.focusOffset,      //光标位置
            sentContext: innerText,           //文本内容
            editType: type,                   //编辑的是原文还是译文
            optType: 1,                       //操作类型
            isEdit: 1,                        //正在编辑 1 编辑完成0
          }
          //发送消息
          this.WEBSOCKET_MESSAGE(params)
        }
      }
      if (this.editorMode !== "mark" || type !== 'target') {
        return;
      }
      this.endRange = saveSelection();
      //获取要操作的dom元素
      let dom = e.target;
      // console.log(dom, e, this.endRange);
      switch (e.inputType) {
        case "insertText": //输入
          // case 'insertCompositionText': //输入中文时需特殊处理
          if (!this.startRange.delStr) {
            //点击输入
            console.log("点击输入");
            if (
              !this.endRange.commonAncestorContainer.parentNode.className.includes(
                "insert"
              )
            ) {
              let insertInsertDom = document.createElement("span");
              insertInsertDom.innerHTML = e.data;
              insertInsertDom.setAttribute("class", "insert");
              let leftDom = null;
              let rightDom = null;
              if (
                this.startRange.startContainer.className ===
                this.startRange.endContainer.className &&
                this.startRange.startContainer.data === undefined
              ) {
                console.log("当前方是特殊标签时");
                // return
                if (
                  this.endRange.commonAncestorContainer.parentNode === e.target
                ) {
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.nextElementSibling
                  );
                  dom.removeChild(this.endRange.commonAncestorContainer);
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else if (
                  this.endRange.commonAncestorContainer.parentNode.nodeName ===
                  "SPAN"
                ) {
                  rightDom = document.createElement("span");
                  rightDom.innerHTML = this.endRange.endContainer.data.slice(
                    this.endRange.endOffset
                  );
                  rightDom.setAttribute(
                    "class",
                    this.endRange.endContainer.parentNode.className
                  );
                  rightDom &&
                    dom.insertBefore(
                      rightDom,
                      this.endRange.commonAncestorContainer.parentNode
                        .nextElementSibling
                    );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode
                      .nextElementSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else {
                  console.log("重复删除输入");
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextElementSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                }
                return;
              } else if (
                this.endRange.endOffset === this.endRange.endContainer.length
              ) {
                //在最后输入添加
                console.log("在最后输入添加");
                leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.endContainer.data.slice(
                  0,
                  this.endRange.endOffset - e.data.length
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                if (this.endRange.commonAncestorContainer.data === e.data) {
                  //重复删除输入
                  console.log(
                    "重复删除输入",
                    leftDom,
                    insertInsertDom,
                    rightDom
                  );
                  if (
                    this.endRange.commonAncestorContainer.parentNode ===
                    e.target
                  ) {
                    console.log("特殊标记前的重复输入");
                  }
                  if(!this.endRange.commonAncestorContainer.parentNode.parentNode.nextElementSibling && !this.endRange.commonAncestorContainer.parentNode.parentNode.previousElementSibling){
                      dom.insertBefore(
                        insertInsertDom,
                        this.endRange.commonAncestorContainer.parentNode.parentNode.parentNode
                          .nextElementSibling
                      );
                      this.endRange.commonAncestorContainer.parentNode.parentNode.parentNode.removeChild(
                        this.endRange.commonAncestorContainer.parentNode.parentNode
                        );
                      this.setRangeIndex(
                        insertInsertDom.childNodes[0],
                        insertInsertDom.childNodes[0].length
                      );
                      return
                  }else{
                    dom.insertBefore(
                      insertInsertDom,
                      this.endRange.commonAncestorContainer.parentNode.parentNode
                        .nextElementSibling
                    );
                    this.endRange.commonAncestorContainer.parentNode.parentNode.removeChild(
                      this.endRange.commonAncestorContainer.parentNode
                      );
                    this.setRangeIndex(
                      insertInsertDom.childNodes[0],
                      insertInsertDom.childNodes[0].length
                    );
                    return
                  }
                }
              } else if (this.endRange.endOffset > 1) {
                //在中间添加
                console.log("在中间添加");
                leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.endContainer.data.slice(
                  0,
                  this.endRange.endOffset - e.data.length
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
              } else {
                //在开头添加
                console.log("在开头添加");
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
              }
              // console.log(leftDom, insertInsertDom, rightDom);
              rightDom &&
                dom.insertBefore(
                  rightDom,
                  this.endRange.commonAncestorContainer.parentNode
                    .nextElementSibling
                );
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.parentNode
                  .nextElementSibling
              );
              leftDom &&
                dom.insertBefore(
                  leftDom,
                  this.endRange.commonAncestorContainer.parentNode
                    .nextElementSibling
                );
              dom.removeChild(this.endRange.commonAncestorContainer.parentNode);
              this.setRangeIndex(
                insertInsertDom.childNodes[0],
                insertInsertDom.childNodes[0].length
              );
            } else {
              //在新增中输入
              console.log('在新增中输入');
            }
          } else {
            //划词输入
            console.log("划词输入");
            let insertInsertDom = document.createElement("span");
            insertInsertDom.innerHTML = e.data;
            insertInsertDom.setAttribute("class", "insert");
            let insertDelDom = document.createElement("span");
            insertDelDom.innerHTML = this.startRange.delStr;
            insertDelDom.setAttribute("class", "del");
            if (this.endRange.endContainer.length === this.endRange.endOffset) {
              console.log("当光标所处位置的前一个元素为一个单元整体时");
              dom.insertBefore(
                insertDelDom,
                this.endRange.commonAncestorContainer.parentNode
                  .nextElementSibling
              );
              if (
                !this.startRange.startContainer.className.includes("insert")
              ) {
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode
                    .nextElementSibling
                );
                console.log("当光标所处位置的前一个元素为一个单元整体时");
                dom.insertBefore(
                  insertDelDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                if (
                  !this.startRange.startContainer.className.includes("insert")
                ) {
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                }
              } else if (
                this.endRange.startContainer === this.endRange.endContainer &&
                this.endRange.endOffset === 0
              ) {
                console.log("最前方已没有数据");
                dom.insertBefore(
                  insertDelDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
              } else if (
                this.endRange.startContainer === this.endRange.endContainer &&
                this.endRange.endContainer === e.target
              ) {
                //当前方是特殊标签时
                console.log("当前方是特殊标签时");
                dom.insertBefore(
                  insertDelDom,
                  this.endRange.commonAncestorContainer.childNodes[
                  this.endRange.endOffset
                  ]
                );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.childNodes[
                  this.endRange.endOffset
                  ]
                );
              } else {
                //从中间划词删
                console.log("从中间划词删并添加输入文字");
                if (
                  !this.startRange.startContainer.className.includes("insert")
                ) {
                  let leftDom = document.createElement("span");
                  leftDom.innerHTML = this.endRange.startContainer.data.slice(
                    0,
                    this.startRange.startOffset
                  );
                  leftDom.setAttribute(
                    "class",
                    this.endRange.startContainer.parentNode.className
                  );
                  let rightDom = document.createElement("span");
                  rightDom.innerHTML = this.endRange.endContainer.data.slice(
                    this.endRange.endOffset
                  );
                  rightDom.setAttribute(
                    "class",
                    this.endRange.endContainer.parentNode.className
                  );
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode
                      .nextElementSibling
                  );
                  dom.insertBefore(
                    insertDelDom,
                    this.endRange.commonAncestorContainer.parentNode
                      .nextElementSibling
                  );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode
                      .nextElementSibling
                  );
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode
                      .nextElementSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else if (
                  this.endRange.startContainer === this.endRange.endContainer &&
                  this.endRange.endOffset === 0
                ) {
                  console.log("最前方已没有数据");
                  dom.insertBefore(
                    insertDelDom,
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode
                  );
                } else if (
                  this.endRange.startContainer === this.endRange.endContainer &&
                  this.endRange.endContainer === e.target
                ) {
                  //当前方是特殊标签时
                  console.log("当前方是特殊标签时");
                  dom.insertBefore(
                    insertDelDom,
                    this.endRange.commonAncestorContainer.childNodes[
                    this.endRange.endOffset
                    ]
                  );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.childNodes[
                    this.endRange.endOffset
                    ]
                  );
                } else {
                  //从中间划词删
                  console.log("从中间划词删并添加输入文字");
                  if (
                    !this.startRange.startContainer.className.includes("insert")
                  ) {
                    let leftDom = document.createElement("span");
                    leftDom.innerHTML = this.endRange.startContainer.data.slice(
                      0,
                      this.startRange.startOffset
                    );
                    leftDom.setAttribute(
                      "class",
                      this.endRange.startContainer.parentNode.className
                    );
                    let rightDom = document.createElement("span");
                    rightDom.innerHTML = this.endRange.endContainer.data.slice(
                      this.endRange.endOffset
                    );
                    rightDom.setAttribute(
                      "class",
                      this.endRange.endContainer.parentNode.className
                    );
                    dom.insertBefore(
                      rightDom,
                      this.endRange.commonAncestorContainer.parentNode
                        .nextSibling
                    );
                    dom.insertBefore(
                      insertDelDom,
                      this.endRange.commonAncestorContainer.parentNode
                        .nextSibling
                    );
                    dom.insertBefore(
                      insertInsertDom,
                      this.endRange.commonAncestorContainer.parentNode
                        .nextSibling
                    );
                    dom.insertBefore(
                      leftDom,
                      this.endRange.commonAncestorContainer.parentNode
                        .nextSibling
                    );
                    dom.removeChild(
                      this.endRange.commonAncestorContainer.parentNode
                    );
                    this.setRangeIndex(
                      insertInsertDom.childNodes[0],
                      insertInsertDom.childNodes[0].length
                    );
                  }
                }
              }
            }
          }
          break;
        case "insertFromPaste": //粘贴的
          console.log("粘贴输入的", this.pastedData);
          if (!this.startRange.delStr) {
            //点击输入
            // console.log("点击输入");
            let insertInsertDom = document.createElement("span");
            insertInsertDom.innerHTML = this.pastedData;
            insertInsertDom.setAttribute("class", "insert");
            let leftDom = null;
            let rightDom = null;
            if (
              this.startRange.startContainer.className ===
              this.startRange.endContainer.className &&
              this.startRange.startContainer.data === undefined
            ) {
              console.log("当前方是特殊标签时");
              if (
                this.endRange.commonAncestorContainer.parentNode === e.target
              ) {
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.nextSibling
                );
                dom.removeChild(this.endRange.commonAncestorContainer);
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              } else if (
                this.endRange.commonAncestorContainer.parentNode.nodeName ===
                "SPAN"
              ) {
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                rightDom &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              } else {
                console.log("重复删除输入");
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                    .nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              }
              return;
            } else if (
              this.startRange.endOffset > 0 &&
              this.startRange.endOffset < this.startRange.endContainer.length
            ) {
              //在中间添加
              console.log("在中间添加", this.endRange.endContainer.parentNode);
              if (
                this.endRange.commonAncestorContainer.parentNode.parentNode ===
                e.target
              ) {
                leftDom = document.createElement("span");
                leftDom.innerHTML =
                  this.endRange.endContainer.parentNode.outerText.slice(
                    0,
                    this.startRange.endOffset
                  );
                leftDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                rightDom = document.createElement("span");
                rightDom.innerHTML =
                  this.endRange.endContainer.parentNode.outerText
                    .slice(this.startRange.endOffset + this.pastedData.length)
                    .trim();
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                // console.log(
                //   leftDom,
                //   insertInsertDom,
                //   rightDom,
                //   this.endRange.commonAncestorContainer.parentNode,
                //   this.endRange.commonAncestorContainer.parentNode.nextSibling
                // );
                rightDom &&
                  rightDom.innerHTML.length > 0 &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                leftDom &&
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              } else {
                leftDom = document.createElement("span");
                leftDom.innerHTML =
                  this.endRange.endContainer.parentNode.parentNode.outerText.slice(
                    0,
                    this.startRange.endOffset
                  );
                leftDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.parentNode.className
                );
                rightDom = document.createElement("span");
                rightDom.innerHTML =
                  this.endRange.endContainer.parentNode.parentNode.outerText
                    .slice(this.startRange.endOffset + this.pastedData.length)
                    .trim();
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.parentNode.className
                );
                // console.log(
                //   leftDom,
                //   insertInsertDom,
                //   rightDom,
                //   this.endRange.commonAncestorContainer.parentNode.parentNode,
                //   this.endRange.commonAncestorContainer.parentNode.parentNode
                //     .nextSibling
                // );
                rightDom &&
                  rightDom.innerHTML.length > 0 &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextSibling
                  );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                    .nextSibling
                );
                leftDom &&
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              }
              return;
            } else if (this.startRange.isEnd) {
              //在最后输入添加
              console.log("在最后输入添加");
              if (
                this.endRange.commonAncestorContainer.parentNode === e.target
              ) {
                // console.log(111);
                let parentDom =
                  this.endRange.commonAncestorContainer.parentNode;
                let clearDomList = [];
                parentDom.childNodes.forEach((element, index) => {
                  if (index > this.startRange.endContainer.index) {
                    clearDomList.push(element);
                  }
                });
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
                // console.log(clearDomList);
                clearDomList.forEach((element) => {
                  dom.removeChild(element);
                });
              } else {
                // console.log(222);
                if (
                  this.endRange.commonAncestorContainer.parentNode.className.includes(
                    "equal"
                  ) ||
                  this.endRange.commonAncestorContainer.parentNode.className.includes(
                    "del"
                  ) ||
                  this.endRange.commonAncestorContainer.parentNode.className.includes(
                    "insert"
                  )
                ) {
                  console.log("2-1");
                  leftDom = document.createElement("span");
                  leftDom.innerHTML =
                    this.endRange.commonAncestorContainer.data.slice(
                      0,
                      this.endRange.endOffset - this.pastedData.length
                    );
                  leftDom.setAttribute(
                    "class",
                    this.endRange.commonAncestorContainer.parentNode.className
                  );
                  // console.log(leftDom, insertInsertDom);
                  return;
                  leftDom &&
                    dom.insertBefore(
                      leftDom,
                      this.endRange.commonAncestorContainer.parentNode
                    );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else {
                  console.log("2-2");
                  let parentDom =
                    this.endRange.commonAncestorContainer.parentNode.parentNode;
                  let clearDomList = [];
                  parentDom.childNodes.forEach((element, index) => {
                    if (index > this.startRange.endContainer.index) {
                      clearDomList.push(element);
                    }
                  });
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode
                  );
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                  // console.log(clearDomList);
                  clearDomList.forEach((element) => {
                    dom.removeChild(element);
                  });
                }
              }
              return;
            } else if (
              this.startRange.startOffset === 0 &&
              this.startRange.endOffset === 0 &&
              this.startRange.startContainer.index === 0 &&
              this.startRange.endContainer.index === 0
            ) {
              //在开头添加
              console.log(
                "在开头添加",
                this.endRange.commonAncestorContainer.parentNode.parentNode
              );

              let clearDomList = [];
              if (
                this.endRange.commonAncestorContainer.parentNode.parentNode ===
                e.target
              ) {
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
                rightDom = document.createElement("span");
                rightDom.innerHTML =
                  this.endRange.commonAncestorContainer.data.slice(
                    this.endRange.endOffset
                  );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                rightDom &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
              } else {
                let parentDom =
                  this.endRange.commonAncestorContainer.parentNode.parentNode;
                let pass = false;
                parentDom.childNodes.forEach((element, index) => {
                  if (!pass) {
                    clearDomList.push(element);
                  }
                  if (element === this.endRange.endContainer.parentNode) {
                    pass = true;
                  }
                });
                // console.log(
                //   clearDomList,
                //   this.endRange.commonAncestorContainer.parentNode,
                //   insertInsertDom
                // );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
                clearDomList.forEach((element) => {
                  this.endRange.commonAncestorContainer.parentNode.parentNode.removeChild(
                    element
                  );
                });
              }
              return;
            } else if (
              this.startRange.endOffset === this.startRange.endContainer.length
            ) {
              //在元素后方复制
              console.log("在元素后方复制");
              if (this.startRange.nextData) {
                console.log("在元素后方复制1");
                if (
                  this.endRange.commonAncestorContainer.parentNode
                    .parentNode === e.target
                ) {
                  rightDom = document.createElement("span");
                  rightDom.innerHTML = this.startRange.nextData;
                  rightDom.setAttribute("class", this.startRange.nextClass);
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode
                  ); //删除项
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else {
                  rightDom = document.createElement("span");
                  rightDom.innerHTML = this.startRange.nextData;
                  rightDom.setAttribute("class", this.startRange.nextClass);
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextSibling
                  );
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                      .nextSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode.parentNode
                  ); //删除项
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                }
              } else {
                console.log("在元素后方复制2");
                if (
                  this.endRange.commonAncestorContainer.parentNode === e.target
                ) {
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.nextSibling
                  );
                  dom.removeChild(this.endRange.commonAncestorContainer); //删除项
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                } else {
                  dom.insertBefore(
                    insertInsertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode
                  ); //删除项
                  this.setRangeIndex(
                    insertInsertDom.childNodes[0],
                    insertInsertDom.childNodes[0].length
                  );
                }
              }
              return;
            }
            // console.log(leftDom, insertInsertDom, rightDom);
            // console.log(
            //   this.endRange.commonAncestorContainer.parentNode.parentNode
            // );

            // rightDom && dom.insertBefore(rightDom, this.endRange.commonAncestorContainer.parentNode.parentNode.nextSibling);
            // dom.insertBefore(insertInsertDom, this.endRange.commonAncestorContainer.parentNode.parentNode.nextSibling);
            // leftDom && dom.insertBefore(leftDom, this.endRange.commonAncestorContainer.parentNode.parentNode.nextSibling);
            // dom.removeChild(this.endRange.commonAncestorContainer.parentNode.parentNode) //删除项
            // this.setRangeIndex(insertInsertDom.childNodes[0], insertInsertDom.childNodes[0].length)
          } else {
            //划词输入
            console.log("划词输入");
            let insertInsertDom = document.createElement("span");
            insertInsertDom.innerHTML = e.data;
            insertInsertDom.setAttribute("class", "insert");
            let insertDelDom = document.createElement("span");
            insertDelDom.innerHTML = this.startRange.delStr;
            insertDelDom.setAttribute("class", "del");
            if (this.endRange.endContainer.length === this.endRange.endOffset) {
              console.log("当光标所处位置的前一个元素为一个单元整体时");
              dom.insertBefore(
                insertDelDom,
                this.endRange.commonAncestorContainer.parentNode.nextSibling
              );
              if (
                !this.startRange.startContainer.className.includes("insert")
              ) {
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endOffset === 0
            ) {
              console.log("最前方已没有数据");
              dom.insertBefore(
                insertDelDom,
                this.endRange.commonAncestorContainer.parentNode
              );
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.parentNode
              );
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endContainer === e.target
            ) {
              //当前方是特殊标签时
              console.log("当前方是特殊标签时");
              dom.insertBefore(
                insertDelDom,
                this.endRange.commonAncestorContainer.childNodes[
                this.endRange.endOffset
                ]
              );
              dom.insertBefore(
                insertInsertDom,
                this.endRange.commonAncestorContainer.childNodes[
                this.endRange.endOffset
                ]
              );
            } else {
              //从中间划词删
              console.log("从中间划词删并添加输入文字");
              if (
                !this.startRange.startContainer.className.includes("insert")
              ) {
                let leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.startContainer.data.slice(
                  0,
                  this.startRange.startOffset
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.startContainer.parentNode.className
                );
                let rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                dom.insertBefore(
                  rightDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  insertDelDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  insertInsertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  leftDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertInsertDom.childNodes[0],
                  insertInsertDom.childNodes[0].length
                );
              }
            }
          }
          break;

        case "deleteContentBackward": //BackSpace删除
          if (!this.startRange.delStr) {
            //不是划词删除
            if (this.startRange.startContainer.className.includes("del")) {
              //del
              let insertDom = document.createElement("span");
              insertDom.innerHTML = this.startRange.startContainer.data;
              insertDom.setAttribute("class", "del");
              if (this.startRange.startOffset === 1) {
                if (this.startRange.startContainer.length > 1) {
                  dom.insertBefore(
                    insertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                      .nextSibling
                  );
                  dom.removeChild(
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  this.setRangeIndex(
                    insertDom.previousElementSibling.childNodes[0],
                    insertDom.previousElementSibling.childNodes[0].length
                  );
                } else {
                  if (
                    this.endRange.startOffset === 0 &&
                    !this.endRange.commonAncestorContainer.parentNode
                      .previousElementSibling
                  ) {
                    //当光标前一个元素都没有时
                    dom.insertBefore(
                      insertDom,
                      this.endRange.commonAncestorContainer.parentNode
                    );
                    this.setRangeIndex(insertDom.childNodes[0], 0);
                  } else {
                    dom.insertBefore(
                      insertDom,
                      this.endRange.commonAncestorContainer.parentNode
                        .nextSibling
                    );
                  }
                }
              } else {
                // console.log(2222);
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertDom.childNodes[0],
                  this.startRange.startOffset - 1
                );
              }
            }
            if (
              (this.startRange.startContainer.className === "equal" &&
                this.startRange.endContainer.className === "equal") ||
              (this.startRange.startContainer.className === "text" &&
                this.startRange.endContainer.className === "text")
            ) {
              //equal 兼容 text
              let insertDom = document.createElement("span");
              insertDom.innerHTML = this.startRange.endContainer.data.slice(
                this.startRange.startOffset - 1,
                this.startRange.endOffset
              );
              insertDom.setAttribute("class", "del");
              // console.log(
              //   insertDom,
              //   this.endRange.commonAncestorContainer.parentNode
              // );
              //将删除的内容以下划线的形式填充到当前位置
              // console.log(this.endRange);
              if (
                this.endRange.startOffset ===
                this.endRange.startContainer.length
              ) {
                //当光标所处位置的前一个元素为一个单元整体时
                console.log("当光标所处位置的前一个元素为一个单元整体时");
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                this.setRangeIndex(
                  insertDom.previousElementSibling.childNodes[0],
                  insertDom.previousElementSibling.childNodes[0].length
                );
              } else if (
                this.endRange.startOffset === 0 &&
                !this.endRange.commonAncestorContainer.parentNode
                  .previousElementSibling
              ) {
                //当光标前一个元素都没有时
                console.log("当光标前一个元素都没有时");
                console.log(
                  this.endRange.commonAncestorContainer.parentNode
                    .previousElementSibling
                );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(insertDom.childNodes[0], 0);
              } else if (
                this.endRange.startContainer === this.endRange.endContainer &&
                this.endRange.endContainer === e.target
              ) {
                //当前方是特殊标签时
                console.log("当前方是特殊标签时");
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.childNodes[
                  this.endRange.endOffset
                  ]
                );
              } else {
                console.log("当前后有元素需要分割时");
                let leftDom = null;
                let rightDom = null;
                if (this.startRange.startOffset > 1) {
                  leftDom = document.createElement("span");
                  leftDom.innerHTML = this.endRange.startContainer.data.slice(
                    0,
                    this.startRange.startOffset - 1
                  );
                  leftDom.setAttribute("class", "equal");
                }
                // console.log(
                //   this.endRange.endContainer,
                //   this.endRange.endOffset
                // );
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                if (this.endRange.endOffset > 0) {
                  rightDom.setAttribute("class", "equal");
                }
                rightDom &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                leftDom &&
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                if (leftDom) {
                  this.setRangeIndex(
                    this.endRange.commonAncestorContainer.childNodes[
                      this.startRange.startContainer.index
                    ].childNodes[0],
                    this.endRange.commonAncestorContainer.childNodes[
                      this.startRange.startContainer.index
                    ].childNodes[0].length
                  );
                } else {
                  this.setRangeIndex(
                    this.endRange.commonAncestorContainer.childNodes[
                      this.startRange.startContainer.index
                    ].childNodes[0],
                    0
                  );
                }
              }
            }
          } else {
            //划词删除
            console.log("划词删除", this.startRange, this.endRange);
            let insertDom = document.createElement("span");
            insertDom.innerHTML = this.startRange.delStr;
            insertDom.setAttribute("class", "del");
            if (this.endRange.endContainer.length === this.endRange.endOffset) {
              console.log("当光标所处位置的前一个元素为一个单元整体时");
              if (
                !(
                  this.startRange.startContainer.className.includes("insert") &&
                  this.startRange.endContainer.className.includes("insert") &&
                  this.startRange.startContainer.data ===
                  this.startRange.endContainer.data
                )
              ) {
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endOffset === 0
            ) {
              console.log("最前方已没有数据");
              if (this.endRange.commonAncestorContainer === e.target) {
                dom.innerHTML = "";
                dom.appendChild(insertDom);
              } else {
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endContainer === e.target
            ) {
              //当前方是特殊标签时
              console.log("当前方是特殊标签时");
              dom.insertBefore(
                insertDom,
                this.endRange.commonAncestorContainer.childNodes[
                this.endRange.endOffset
                ]
              );
            } else {
              //从中间划词删
              console.log("从中间划词删");
              if (
                !this.startRange.startContainer.className.includes("insert")
              ) {
                let leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.startContainer.data.slice(
                  0,
                  this.startRange.startOffset
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.startContainer.parentNode.className
                );
                let rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                dom.insertBefore(
                  rightDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  leftDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  leftDom.childNodes[0],
                  leftDom.childNodes[0].length
                );
              }
            }
          }
          break;
        case "deleteContentForward": //del删除
          if (!this.startRange.delStr) {
            //不是划词删除
            if (this.startRange.startContainer.className.includes("del")) {
              //del
              console.log("del");
              if (this.startRange.nextClass) {
                if (
                  this.startRange.nextClass.includes("equal") ||
                  this.startRange.nextClass.includes("del")
                ) {
                  // console.log(111111);
                  let insertDom = document.createElement("span");
                  insertDom.innerHTML = this.startRange.nextData.slice(0, 1);
                  insertDom.setAttribute("class", "del");
                  dom.insertBefore(
                    insertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  this.setRangeIndex(
                    insertDom.childNodes[0],
                    insertDom.childNodes[0].length
                  );
                }
              } else {
                let insertDom = document.createElement("span");
                insertDom.innerHTML = this.startRange.endContainer.data.slice(
                  this.startRange.startOffset,
                  this.startRange.endOffset + 1
                );
                insertDom.setAttribute("class", "del");
                // console.log(insertDom);
                let leftDom = null;
                let rightDom = null;
                leftDom = document.createElement("span");
                leftDom.innerHTML = this.startRange.startContainer.data.slice(
                  0,
                  this.startRange.startOffset
                );
                leftDom.setAttribute("class", "del");
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute("class", "del");
                // console.log(leftDom, insertDom, rightDom);
                rightDom &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                leftDom &&
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertDom.childNodes[0],
                  insertDom.childNodes[0].length
                );
              }
            } else if (
              (this.startRange.startContainer.className === "equal" &&
                this.startRange.endContainer.className === "equal") ||
              (this.startRange.startContainer.className === "text" &&
                this.startRange.endContainer.className === "text")
            ) {
              //equal 兼容 text
              let insertDom = document.createElement("span");
              insertDom.innerHTML = this.startRange.endContainer.data.slice(
                this.startRange.startOffset,
                this.startRange.endOffset + 1
              );
              insertDom.setAttribute("class", "del");
              // console.log(
              //   insertDom,
              //   this.endRange.commonAncestorContainer.parentNode
              // );
              //将删除的内容以下划线的形式填充到当前位置
              // console.log(this.endRange);
              if (
                this.endRange.startOffset ===
                this.endRange.startContainer.length
              ) {
                //当光标所处位置的前一个元素为一个单元整体时
                console.log("当光标所处位置的前一个元素为一个单元整体时");
                if (!this.startRange.nextData) {
                  dom.insertBefore(
                    insertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  this.setRangeIndex(
                    insertDom.childNodes[0],
                    insertDom.childNodes[0].length
                  );
                } else if (!this.startRange.nextClass.includes("insert")) {
                  let insertDom = document.createElement("span");
                  insertDom.innerHTML = this.startRange.nextData.slice(0, 1);
                  insertDom.setAttribute("class", "del");
                  dom.insertBefore(
                    insertDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                  this.setRangeIndex(
                    insertDom.childNodes[0],
                    insertDom.childNodes[0].length
                  );
                }
              } else if (
                this.endRange.startOffset === 0 &&
                !this.endRange.commonAncestorContainer.parentNode
                  .previousElementSibling
              ) {
                //当光标前一个元素都没有时
                console.log("当光标前一个元素都没有时");
                // console.log(
                //   this.endRange.commonAncestorContainer.parentNode
                //     .previousElementSibling
                // );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertDom.childNodes[0],
                  insertDom.childNodes[0].length
                );
              } else {
                console.log("当前后有元素需要分割时");
                let leftDom = null;
                let rightDom = null;
                leftDom = document.createElement("span");
                leftDom.innerHTML = this.startRange.startContainer.data.slice(
                  0,
                  this.startRange.startOffset
                );
                leftDom.setAttribute("class", "equal");
                // console.log(
                //   this.endRange.endContainer,
                //   this.endRange.endOffset
                // );
                rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                if (this.endRange.endOffset > 0) {
                  rightDom.setAttribute("class", "equal");
                }
                rightDom &&
                  dom.insertBefore(
                    rightDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                leftDom &&
                  dom.insertBefore(
                    leftDom,
                    this.endRange.commonAncestorContainer.parentNode.nextSibling
                  );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertDom.childNodes[0],
                  insertDom.childNodes[0].length
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endContainer === e.target
            ) {
              //当前方是特殊标签时
              let insertDom = document.createElement("span");
              insertDom.innerHTML = this.startRange.nextData.slice(0, 1);
              insertDom.setAttribute("class", "del");
              dom.insertBefore(
                insertDom,
                this.endRange.commonAncestorContainer.childNodes[
                this.endRange.endOffset
                ]
              );
              this.setRangeIndex(
                insertDom.childNodes[0],
                insertDom.childNodes[0].length
              );
            } else if (
              this.startRange.nextData &&
              this.startRange.nextData.length > 0
            ) {
              let insertDom = document.createElement("span");
              insertDom.innerHTML = this.startRange.nextData.slice(0, 1);
              insertDom.setAttribute("class", "del");
              dom.insertBefore(
                insertDom,
                this.endRange.commonAncestorContainer.parentNode.nextSibling
              );
              this.setRangeIndex(
                insertDom.childNodes[0],
                insertDom.childNodes[0].length
              );
            }
          } else {
            //划词删除
            console.log("划词删除", this.startRange, this.endRange);
            let insertDom = document.createElement("span");
            insertDom.innerHTML = this.startRange.delStr;
            insertDom.setAttribute("class", "del");
            if (this.endRange.endContainer.length === this.endRange.endOffset) {
              console.log("当光标所处位置的前一个元素为一个单元整体时");
              if (
                !(
                  this.startRange.startContainer.className.includes("insert") &&
                  this.startRange.endContainer.className.includes("insert") &&
                  this.startRange.startContainer.data ===
                  this.startRange.endContainer.data
                )
              ) {
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endOffset === 0
            ) {
              console.log("最前方已没有数据");
              if (this.endRange.commonAncestorContainer === e.target) {
                dom.innerHTML = "";
                dom.appendChild(insertDom);
              } else {
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode
                );
              }
            } else if (
              this.endRange.startContainer === this.endRange.endContainer &&
              this.endRange.endContainer === e.target
            ) {
              //当前方是特殊标签时
              console.log("当前方是特殊标签时");
              dom.insertBefore(
                insertDom,
                this.endRange.commonAncestorContainer.childNodes[
                this.endRange.endOffset
                ]
              );
            } else {
              //从中间划词删
              console.log("从中间划词删");
              if (
                !this.startRange.startContainer.className.includes("insert")
              ) {
                let leftDom = document.createElement("span");
                leftDom.innerHTML = this.endRange.startContainer.data.slice(
                  0,
                  this.startRange.startOffset
                );
                leftDom.setAttribute(
                  "class",
                  this.endRange.startContainer.parentNode.className
                );
                let rightDom = document.createElement("span");
                rightDom.innerHTML = this.endRange.endContainer.data.slice(
                  this.endRange.endOffset
                );
                rightDom.setAttribute(
                  "class",
                  this.endRange.endContainer.parentNode.className
                );
                dom.insertBefore(
                  rightDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  insertDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.insertBefore(
                  leftDom,
                  this.endRange.commonAncestorContainer.parentNode.nextSibling
                );
                dom.removeChild(
                  this.endRange.commonAncestorContainer.parentNode
                );
                this.setRangeIndex(
                  insertDom.childNodes[0],
                  insertDom.childNodes[0].length
                );
              }
            }
          }
          break;

        case "historyUndo": //撤回
          console.log("撤回");
          // dom.removeChild(insertDom)
          break;
        default:
          break;
      }
    },
    handlePaste(e, item) {
      // if (this.editorMode !== "mark") {
      //   return;
      // }
      // var e = event || window.event;
      // // 阻止默认粘贴
      // e.preventDefault();
      // // 粘贴事件有一个clipboardData的属性，提供了对剪贴板的访问
      // // clipboardData的getData(fomat) 从剪贴板获取指定格式的数据
      // var text =
      //   (e.originalEvent || e).clipboardData.getData("text/plain") ||
      //   prompt("在这里输入文本");
      // //清除回车
      // text = text.replace(/\[\d+\]|\n|\r/gi, "");
      // // 插入
      // document.execCommand("insertText", false, text);
      // this.pastedData = (e.clipboardData || window.clipboardData).getData(
      //   "text"
      // );
      e.preventDefault();
      var text;
      var clp = (e.originalEvent || e).clipboardData;
      if (clp === undefined || clp === null) {
        text = window.clipboardData.getData("text") || "";
        if (text !== "") {
          if (window.getSelection) {
            var newNode = document.createElement("span");
            newNode.innerHTML = text;
            window.getSelection().getRangeAt(0).insertNode(newNode);
          } else {
            document.selection.createRange().pasteHTML(text);
          }
        }
      } else {
        text = clp.getData('text/plain') || "";
        if (text !== "") {
          document.execCommand('insertText', false, text);
        }
      }
      // console.log(222222222223333, e, item, this.endRange, this.pastedData);
    },
    //光标位置重新处理
    setRangeIndex(dom, index) {
      //光标位置处理
      // 创建新的光标对象
      let range = document.createRange();
      // 光标对象的范围界定为新建的表情节点
      range.selectNodeContents(dom);
      // 光标位置定位在表情节点的最大长度
      range.setStart(dom, index);
      // range.setEnd(leftDom, leftDom.length)
      // 使光标开始和光标结束重叠
      range.collapse(true);
      restoreSelection(range);
    },
    getStartRange() {
      let tempRange = saveSelection();
      let startIndex = null;
      let endIndex = null;
      let delStr = "";
      let parentNode = null;
      if (tempRange) {
        if (tempRange.endContainer === tempRange.startContainer) {
          parentNode = tempRange.commonAncestorContainer.parentNode.parentNode;
          if (tempRange.commonAncestorContainer.data) {
            delStr = tempRange.commonAncestorContainer.data.slice(
              tempRange.startOffset,
              tempRange.endOffset
            );
          }
        } else {
          parentNode = tempRange.commonAncestorContainer;
        }
      }
      parentNode.childNodes.forEach((item, index) => {
        if (item === tempRange.startContainer.parentNode) {
          startIndex = index;
          if (
            tempRange.endContainer !== tempRange.startContainer &&
            item.className &&
            !item.className.includes("insert")
          ) {
            delStr += item.outerText.slice(tempRange.startOffset);
          }
        }
        if (item === tempRange.endContainer.parentNode) {
          endIndex = index;
          if (
            tempRange.endContainer !== tempRange.startContainer &&
            item.className &&
            !item.className.includes("insert")
          ) {
            delStr += item.outerText.slice(0, tempRange.endOffset);
          }
        }
        if (tempRange.endContainer !== tempRange.startContainer) {
          // console.log(tempRange, item);
          if (
            item.className &&
            !item.className.includes("insert") &&
            startIndex !== null &&
            index > startIndex &&
            endIndex === null
          ) {
            delStr += item.outerText;
          }
          if (
            item.className &&
            !item.className.includes("insert") &&
            startIndex !== null &&
            endIndex !== null &&
            index > startIndex &&
            index < startIndex
          ) {
            delStr += item.outerText;
          }
        }
      });
      this.startRange = {
        startOffset: tempRange.startOffset,
        endOffset: tempRange.endOffset,
        delStr: delStr,
        startContainer: {
          data: tempRange.startContainer.data,
          length: tempRange.startContainer.length,
          index: startIndex,
          className: tempRange.startContainer.parentNode.className,
        },
        endContainer: {
          data: tempRange.endContainer.data,
          length: tempRange.endContainer.length,
          index: endIndex,
          className: tempRange.endContainer.parentNode.className,
        },
        nextData: null,
        nextClass: null,
        isEnd: false,
      };
      if (
        !this.startRange.endContainer.data &&
        !this.startRange.startContainer.data
      ) {
        if (tempRange.commonAncestorContainer.childNodes[tempRange.endOffset]) {
          this.startRange.nextData =
            tempRange.commonAncestorContainer.childNodes[
              tempRange.endOffset
            ].outerText;
          this.startRange.nextClass =
            tempRange.commonAncestorContainer.childNodes[
              tempRange.endOffset
            ].className;
        }
      } else if (
        tempRange.endOffset === tempRange.commonAncestorContainer.length
      ) {
        // console.log(tempRange.commonAncestorContainer.parentNode.nextSibling);
        if (tempRange.commonAncestorContainer.parentNode.nextSibling) {
          this.startRange.nextData =
            tempRange.commonAncestorContainer.parentNode.nextSibling.outerText;
          this.startRange.nextClass =
            tempRange.commonAncestorContainer.parentNode.nextSibling.className;
        }
      }
      if (
        this.startRange.endContainer.index ===
        parentNode.childNodes.length - 1 &&
        this.startRange.endOffset === this.startRange.endContainer.length
      ) {
        this.startRange.isEnd = true;
      }
      // console.log("startRange:", this.startRange);
    },
    //跳转当前页
    gotopage() {
      this.changegoPage();
    },
    //change跳转
    changegoPage() {
      let param = this.$store.getters["editor/getTaskContentListParams"];
      if (this.getTaskContentList.totalPage) {
        this.totalPage = this.getTaskContentList.totalPage;
      }
      if (this.page > this.totalPage) {
        this.page = this.totalPage;
      } else if (this.page < 1) {
        this.page = 1;
      } else if (typeof this.page !== "number") {
        this.page = 1;
      }
      const { type } = this.getUrlInfo;
      param.startSort = this.page;
      param.urltype = type;
      this.$store.dispatch("editor/continueLoadContent", param);
      this.$nextTick(() => {
        document.getElementById("editorBox").scrollTop = 0;
      });
    },
    //上一页句子
    handlerPrev() {
      let param = this.$store.getters["editor/getTaskContentListParams"];
      if (this.getTaskContentList.totalPage) {
        this.totalPage = this.getTaskContentList.totalPage;
      }
      if (param.startSort === 1) {
        this.$message.closeAll();
        this.$message.warning("当前已在第一页");
        return;
      }
      const { type } = this.getUrlInfo;
      param.startSort--;
      this.page = param.startSort;
      param.urltype = type;
      this.$store.dispatch("editor/continueLoadContent", param);
      this.$nextTick(() => {
        document.getElementById("editorBox").scrollTop = 0;
      });
    },
    //下一页句子
    handlerNext() {
      let param = this.$store.getters["editor/getTaskContentListParams"];
      if (this.getTaskContentList.totalPage) {
        this.totalPage = this.getTaskContentList.totalPage;
      }
      if (param.startSort === this.totalPage) {
        this.$message.closeAll();
        this.$message.warning("当前已在最后一页");
        return;
      }
      const { type } = this.getUrlInfo;
      param.startSort++;
      this.page = param.startSort;
      param.urltype = type;
      this.$store.dispatch("editor/continueLoadContent", param);
      this.$nextTick(() => {
        document.getElementById("editorBox").scrollTop = 0;
      });
    },
    //获取序号
    getinside(page, index) {
      let num = parseInt(index + 1);
      if (page > 1) {
        return (page - 1) * 50 + num;
      } else {
        if (num > 9) {
          return num;
        } else {
          return "0" + num;
        }
      }
    },
    // 获取没有内容的句子
    getisContent(id) {
      let flag = this.getcountTargetIsnullIdList.includes(id);
      if (flag) {
        return "redborder";
      } else {
        return "noborder";
      }
    },
    setPreviewInfo(index = 1) {
      this.index = 1;
      let params = Object();
      let fileId = 0;
      let taskId = 0;
      const { type } = this.urlInfo;
      if (type === "project") {
        fileId = this.getFileInfo.id || this.urlInfo.fileId;
      } else if (type === "task" || type === "school") {
        fileId = this.getFileTaskInfo.fileId || this.urlInfo.fileId;
        taskId = this.getFileTaskInfo.id || this.urlInfo.taskId;
      }
      // Reflect.set(params, 'partIndex', 1);
      Reflect.set(params, "fileId", fileId);
      Reflect.set(params, "taskId", taskId);
      Reflect.set(params, "partIndex", index);
      this.$store.dispatch("editor/setAppointPreview", params);
    },
    //点击qa图标显示右侧内容
    changeQA(item) {
      console.log("QA-----------");
      let params2 = {};
      Reflect.set(params2, "item", item);
      Reflect.set(params2, "type", "QA");
      this.$store.dispatch("editor/setTempSentenceId", params2);
      let QA_Params = {};
      const { taskId, taskType } = this.getUrlInfo;
      let { fileId } = this.getFileTaskInfo;
      Reflect.set(QA_Params, "fileId", fileId);
      Reflect.set(QA_Params, "taskId", taskId);
      Reflect.set(QA_Params, "sentId", item.id);
      Reflect.set(QA_Params, "taskType", parseInt(taskType));
      this.$store.dispatch("editor/fragmentQAInfo", QA_Params);
      let signParams = {};
      Reflect.set(signParams, "column", "third");
      Reflect.set(signParams, "keyword", null);
      this.$store.dispatch("editor/setOerationSignInfo", signParams);
      // 置空记忆库术语库机翻
      this.$store.dispatch("editor/setSentMemoryInfo2", []);
      this.$store.dispatch("editor/setSentTermInfo2", []);
      this.$store.dispatch("editor/setSentenceMt2", []);
      this.$store.dispatch("editor/setEditorRightActiveName", "first");
    },
    showQAList(item) {
      console.log(item, '@@QA', this.getQAList);
      this.itemQAList = this.getQAList.filter(i => i.transFileSentId == item.id)
    },
    handleMousedown(e, type) {
      this.clientY = e.clientY;
      this.clientX = e.clientX;
      this.mousedownType = type
    },

    toggleFlag(e, item, type) {
      console.log('获取焦点', item)
      this.isChangeModifyingRecords = 0
      let Arr = [];
      let childrenNodeAll = e.target.childNodes;
      let innerText = trimSpace(e.target.innerText);
      if (innerText) {
        this.info = domArray(childrenNodeAll, item, Arr, "filterDel");
      }
      this.info.content = innerText;
      if (this.lockState(item)) {
        this.flag = item.id + type;
      }
      const { type: fromType } = this.getUrlInfo
      if (fromType == 'task') {
        let selection = window.getSelection()
        const { projectId, fileId, companyCode } = this.getFileTaskInfo
        let params = {
          type: 'editTransFileSent',
          companyCode,                      //公司编码
          projectId,                        //项目id
          fileId,                           //文件id
          userId: this.getUserInfo.id,      //用户id
          userName: this.getUserInfo.nickName,   //用户名字
          sentId: item.id,                  //句子id
          index: selection.focusOffset,      //光标位置
          sentContext: innerText,           //文本内容
          editType: type,                   //编辑的是原文还是译文
          optType: 0,                       //操作类型
          isEdit: 1,                        //正在编辑 1 编辑完成0
        }
        // sendMsg(params)
        //发送消息
        this.WEBSOCKET_MESSAGE(params)
      } else if (fromType == 'project') {
        let selection = window.getSelection()
        const { projectId, id: fileId, companyCode } = this.getFileInfo
        let params = {
          type: 'adminEditTransFileSent',
          companyCode,                      //公司编码
          projectId,                        //项目id
          fileId,                           //文件id
          userId: this.getUserInfo.id,      //用户id
          userName: '项目经理',   //用户名字
          sentId: item.id,                  //句子id
          index: selection.focusOffset,      //光标位置
          sentContext: innerText,           //文本内容
          editType: type,                   //编辑的是原文还是译文
          optType: 0,                       //操作类型
          isEdit: 1,                        //正在编辑 1 编辑完成0
        }
        // sendMsg(params)
        //发送消息
        this.WEBSOCKET_MESSAGE(params)
      }


    },
    handleClickUpdataState(e) {
      if (e.target.getAttribute("typeInfo")) {
        this.typeInfo = e.target.getAttribute("typeInfo");
      } else {
        this.clickInfo = {
          event: e,
          rang: saveSelection(),
        };
      }
    },

    //点击事件：获取当前的id-获取记忆库/术语库-获取批注
    async handleEditor(e, item, sentenceType, keyboard) {
      console.log('编辑');
      if (!this.getUrlInfo) {
        return;
      }
      const { projectId, fileId, taskId, type, taskType } = this.getUrlInfo;

      // //如果是项目经理从项目进入编辑器
      let isPM = this.getUserInfo.id == this.getProjectInfo.creatorId;
      if (isPM && type === 'project') {
        //设置当前的句子，可以右键进行操作
        this.currentItem = item;
        this.currentId = `${item.id}`;
        this.currentIdType = `${sentenceType}-${item.id}`;
        //设置插入的信息
        let params2 = {}
        Reflect.set(params2, "item", item);
        Reflect.set(params2, "type", sentenceType);
        this.$store.dispatch("editor/setTempSentenceId", params2);
      }

      if (sentenceType === "target") {
        this.getTargetEditorState(item, sentenceType);
        this.$store.dispatch("editor/setTargeteditEditorStatus", true);
      } else {
        this.$store.dispatch("editor/setSourceeditEditorStatus", true);
      }
      // 点击句子后 将右侧tab 切换到 翻译建议
      this.$store.dispatch("editor/setEditorRightActiveName", "first");
      //如果是作业/测试相关--原文不可以修改
      //聚焦显示单句修改记录
      let params = {};
      if (item) {
        Reflect.set(params, "transProjectId", projectId);
        Reflect.set(params, "transFileId", fileId);
        Reflect.set(params, "taskId", taskId);
        Reflect.set(params, "sentId", item.id);
        Reflect.set(params, "partIndex", 1);
        this.$store.dispatch("editor/setModifyRecordInfo", params);
      }
      this.typeInfo = null;
      // if (!(type === 'school' && sentenceType === 'source')) {
      if (this.lockState(item)) {
        let dom = document.getElementById(`${sentenceType}-${item.id}`);
        if (dom) {
          let Ele = dom.getElementsByClassName("hightLight");
          let Ele2 = dom.getElementsByClassName("term");
          //处理术语高亮
          if (Ele2.length) {
            Array.prototype.forEach.call(Ele2, function (item) {
              item.innerHTML = item.innerText;
              item.parentNode.innerText = item.parentNode.innerText;
            });
          }
          //处理检索高亮
          if (Ele.length) {
            this.$message.closeAll();
            this.$message({
              message:
                "当前句子包含检索高亮词,请刷新页面或者清除高亮再进行编辑",
              type: "warning",
            });
            this.$store.dispatch("editor/setSourceeditEditorStatus", false);
            this.$store.dispatch("editor/setEleStatus", false);
            return false;
          } else {
            this.$store.dispatch("editor/setEleStatus", true);
          }
        }
        //记录光标的位置
        if (keyboard !== "enter") {
          this.range = saveSelection();
        } else {
          this.range = null;
        }
        let currentSentenceInfo =
          this.$store.getters["editor/getCurrentSentenceIdInfo"];
        let fileId = null;
        let targetLang = "en";
        let sourceLang = "zh";
        if (type === "project") {
          fileId = this.getFileInfo.id;
          sourceLang = this.getFileInfo.sourceLang;
          targetLang = this.getFileInfo.targetLang;
        } else if (type === "task" || type === "school") {
          fileId = this.getFileTaskInfo.fileId;
          sourceLang = this.getFileTaskInfo.sourceLang;
          targetLang = this.getFileTaskInfo.targetLang;
        }
        this.currentIdType = `${sentenceType}-${item.id}`;
        if (
          currentSentenceInfo.currentIdType !== `${sentenceType}-${item.id}`
        ) {
          // 如果这一次点击的句子和上一次点击的句子不是同一句 就将机翻、记忆库、术语库、QA结果置空

          this.currentItem = item;
          this.currentId = `${item.id}`;
          //如果是Ctrl寻找下一待确认句子就滚动元素到视口
          if (this.isScollerView) {
            this.isScollerView = false;
            this.$nextTick(() => {
              document.querySelector(`.active-section`).scrollIntoView();
            });
          }

          this.currentIdType = `${sentenceType}-${item.id}`;
          let params = {};
          let params2 = {};
          Reflect.set(params, "currentId", `${item.id}`);
          Reflect.set(params, "currentIdType", `${sentenceType}-${item.id}`);
          Reflect.set(params2, "item", item);
          Reflect.set(params2, "type", sentenceType);
          this.$store.dispatch("editor/setCursorId", params);
          this.$store.dispatch("editor/setTempSentenceId", params2);
          this.$nextTick(async () => {
            this.oldtimeStamp = moment().valueOf() / 1000; //获取当前时间秒数
            if (this.range) {
              //将光标的位置设置回来
              restoreSelection(this.range);
              this.range = null;
            } else {
              //焦点定位到最后
              if (dom.childElementCount > 0) {
                // console.log(
                //   dom.childNodes[dom.childElementCount - 1] &&
                //     dom.childNodes[dom.childElementCount - 1].childNodes[0]
                // );
                console.log('设置光标');

                const lastChild = dom.lastElementChild;
                if (lastChild) {
                  // console.log(lastChild.childNodes[0],'*---------*');
                  setCursorEnd(lastChild.childNodes[0]);
                }
                this.getStartRange();
              } else {
                setCursorEnd(dom);
              }
            }
            //如果是作业-测试相关隐匿请求获取术语库和记忆库的操作
            // if (urlInfo.type !== 'school') {
            // 机翻
            if (this.isPreMt && this.haveAT) {
              try {
                // 机翻参数
                let mtParams = {
                  fileId,
                  sid: item.id,
                  taskType,
                };
                const { result, success } = await this.$store.dispatch(
                  "editor/setSentenceMt",
                  mtParams
                );
                success &&
                  result &&
                  this.$store.dispatch("editor/setSentenceMt2", [result]);
              } catch (error) {
                this.$message.closeAll();
                this.$message.error("机器翻译-错误提示");
              }
            }
            // 记忆库 术语库
            try {
              // 记忆库参数
              let memoryParams = {
                fileId,
                sourcePar: item.sourceSent,
                sourceIndex: item.sourceWordNum,
                taskType,
              };
              // 术语库参数
              let termParams = {
                fileId,
                sourceSent: item.sourceSent,
                sourceLang,
                targetLang,
                taskType,
                // transModel: 1
              };

              const ajaxBankeArr = [
                this.$store.dispatch("editor/setSentMemoryInfo", memoryParams),
                this.$store.dispatch("editor/setSentTermInfo", termParams),
              ];
              const res = await Promise.all(ajaxBankeArr);
              if (!res.length) {
                return;
              }
              const resMemory = res[0].result;
              const resTerm = res[1].result;
              if (resMemory) {
                // if (type === "school") {
                //   const arrResult = resMemory.filter(
                //     (item) => item.source !== 3
                //   );
                //   this.$store.dispatch("editor/setSentMemoryInfo2", arrResult);
                // } else {
                this.$store.dispatch("editor/setSentMemoryInfo2", resMemory);
                // }
              }
              resTerm &&
                this.$store.dispatch("editor/setSentTermInfo2", resTerm);
            } catch (error) {
              this.$message.closeAll();
              this.$message.error("记忆库或者术语库-错误提示");
            }
            // QA结果
            if (this.isOpenQa && ["task", "school"].includes(type)) {
              let QA_Params = {
                fileId,
                taskId,
                sentId: item.id,
                taskType,
              };
              // 当前句子QA信息
              this.$store.dispatch("editor/fragmentQAInfo", QA_Params);
              const QA_ListParams = {
                fileId,
                taskId,
                // transModel: 1
              };
              // QA列表刷新
              this.$store.dispatch("editor/QACheckFileTaskInfo", QA_ListParams);
            }
          });
        }
      }
      // }
    },

    //译文失去焦点/原文失焦事件
    handleBlur(event, row, type, index, isChange) {
      // console.log(row);
      if (this.isRevise) {
        return;
      }
      console.log("失焦");
      if(this.editorMode === "mark"){
        this.info.content = trimSpace(event.target.innerText);
      }
      this.isChangeModifyingRecords = 1
      {
        const { type: fromType } = this.getUrlInfo
        if (fromType == 'task') {
          //发送编辑完成websocket
          const { projectId, fileId, companyCode } = this.getFileTaskInfo
          let innerText = trimSpace(event.target.innerText);
          let params = {
            type: 'editTransFileSent',
            companyCode,                      //公司编码
            projectId,                        //项目id
            fileId,                           //文件id
            userId: this.getUserInfo.id,      //用户id
            sentId: row.id,                  //句子id
            // userName: this.getUserInfo.nickName,   //用户名字
            // index:selection.focusOffset,      //光标位置
            sentContext: innerText,           //文本内容
            editType: type,                   //编辑的是原文还是译文
            optType: 0,                       //操作类型
            isEdit: 0,                        //正在编辑 1 编辑完成0
          }
          // sendMsg(params)
          //发送消息
          this.WEBSOCKET_MESSAGE(params)
        } else if (fromType == 'project') {
          //发送编辑完成websocket
          const { projectId, id: fileId, companyCode } = this.getFileInfo
          let innerText = trimSpace(event.target.innerText);
          let params = {
            type: 'adminEditTransFileSent',
            companyCode,                      //公司编码
            projectId,                        //项目id
            fileId,                           //文件id
            userId: this.getUserInfo.id,      //用户id
            sentId: row.id,                  //句子id
            // userName: this.getUserInfo.nickName,   //用户名字
            // index:selection.focusOffset,      //光标位置
            sentContext: innerText,           //文本内容
            editType: type,                   //编辑的是原文还是译文
            optType: 0,                       //操作类型
            isEdit: 0,                        //正在编辑 1 编辑完成0
          }
          // sendMsg(params)
          //发送消息
          this.WEBSOCKET_MESSAGE(params)
        }
      }
      const self = this;
      this.isupdateStatus = 1;
      const setSentCountInfo = {};
      if (
        event.target.nodeName === "DIV" &&
        event.target.getAttribute("info")
      ) {
        let sentCountInfo = event.target.getAttribute("info");
        if (sentCountInfo) {
          setSentCountInfo.key = sentCountInfo
            .split("*")[0]
            .slice(
              sentCountInfo.split("*")[0].indexOf("{") + 1,
              sentCountInfo.split("*")[0].indexOf("}")
            );
          setSentCountInfo.type = type;
          this.$store.dispatch("editor/setSentCountInfo", setSentCountInfo);
        }
      }
      // 句子失去焦点时，将操作区域 “ 编辑原文 ”状态重置为false
      if (this.getisSourceedit) {
        this.$store.dispatch("editor/setSourceeditEditorisSourceedit", false);
      }
      this.flag = false;
      this.currentId = null;
      this.currentIdType = null;
      this.range = null;
      let params = {
        currentId: null,
        currentIdType: null,
      };
      this.$store.dispatch("editor/setCursorId", params);
      //设置当前编辑的Id
      const { type: entranceType, projectId } = this.getUrlInfo;
      let fileId = 0;
      let taskId = null;
      let taskType = null;
      if (entranceType === "project") {
        fileId = this.getFileInfo.id;
      } else if (entranceType === "task" || entranceType === "school") {
        fileId = this.getFileTaskInfo.fileId;
        taskId = this.getFileTaskInfo.id;
        taskType = this.getFileTaskInfo.taskType;
      }
      let childrenNodeAll = event.target.childNodes;
      // console.log(
      //   event.target,
      //   domArray(childrenNodeAll, row, [], "filterDel")
      // );
      return new Promise((resolve) => {
        let innerText = "";
        if (this.editorMode === "standard") {
          innerText = trimSpace(event.target.innerText);
        } else {
          let tempInnerText = Array.from(event.target.childNodes)
            .map((item) => {
              //处理
              if (item.className && item.className.includes("del")) {
                return "";
              } else {
                return item.outerText;
              }
            })
            .join("");
          innerText = trimSpace(tempInnerText);
        }
        let info = [];
        let Array2 = [];
        let params = {};
        let timeStamp = moment().valueOf() / 1000;
        this.costTime = timeStamp - this.oldtimeStamp;
        if (innerText) {
          info = domArray(childrenNodeAll, row, Array2, "filterDel");
        } else {
          let temp = {};
          Reflect.set(temp, "atomKey", row.templateKey);
          Reflect.set(
            temp,
            "sort",
            `${parseInt(row.id.toString().substr(0, 5))}`
          );
          Reflect.set(temp, "data", "");
          Reflect.set(temp, "style", null);
          Reflect.set(temp, "id", row.id);
          Reflect.set(temp, "dataType", "text");
          Reflect.set(temp, "tagType", "text");
          info.push(temp);
          self.$store.dispatch("editor/setUpdataFragmentType", 4);
        }
        Reflect.set(params, "costTime", Math.floor(this.costTime));
        Reflect.set(params, "taskId", taskId);
        Reflect.set(params, "taskType", taskType);
        Reflect.set(params, "isSaveVersion", 0);
        Reflect.set(params, "sentId", row.id);
        Reflect.set(params, "content", innerText);
        Reflect.set(params, "status", row.status);
        Reflect.set(params, "fileId", fileId);
        Reflect.set(params, "isAfterRevision", isChange ? 1 : 0);
        Reflect.set(
          params,
          "leaveMarkModel",
          this.editorMode === "mark" ? 1 : 0
        );
        if (this.editorMode === "mark") {
          let tagTargetSentHtml = JSON.parse(row.tagTargetSentHtml);
          tagTargetSentHtml.fragments[0].atoms = domArray(
            childrenNodeAll,
            row,
            [],
            "leaveMarkModel"
          );
          // console.log(tagTargetSentHtml);
          Reflect.set(
            params,
            "modifyTracesJson",
            JSON.stringify(tagTargetSentHtml)
          );
        }
        //修改原文
        if (type === "source") {
          let sourceTemp = {};
          Reflect.set(sourceTemp, "sort", 0);
          Reflect.set(sourceTemp, "text", null);
          Reflect.set(sourceTemp, "type", null);
          Reflect.set(sourceTemp, "atoms", info);
          Reflect.set(params, "sourceTagFragmentVo", sourceTemp);
          Reflect.set(params, "targetTagFragmentVo", null);
        }
        //修改译文
        if (type === "target") {
          let targetTemp = {};
          Reflect.set(targetTemp, "sort", 0);
          Reflect.set(targetTemp, "text", null);
          Reflect.set(targetTemp, "type", null);
          Reflect.set(targetTemp, "atoms", info);
          Reflect.set(params, "sourceTagFragmentVo", null);
          Reflect.set(params, "targetTagFragmentVo", targetTemp);
          if (self.updataType === "blur") {
            if (!!self.typeInfo && !!innerText) {
              Reflect.set(params, "isCommitVersion", 1);
            } else {
              Reflect.set(params, "isCommitVersion", 0);
            }
          } else if (self.updataType === "enter") {
            if (innerText) {
              Reflect.set(params, "isCommitVersion", 1);
              Reflect.set(params, "isSaveVersion", 1);
            } else {
              Reflect.set(params, "isCommitVersion", 0);
            }
          } else if (self.updataType === "enterPre") {
            if (innerText) {
              Reflect.set(params, "isCommitVersion", 1);
            } else {
              Reflect.set(params, "isCommitVersion", 0);
            }
          } else if (self.updataType == "nextNotConfirm") {
            if (innerText) {
              Reflect.set(params, "isCommitVersion", 1);
              Reflect.set(params, "isSaveVersion", 1);
            } else {
              Reflect.set(params, "isCommitVersion", 0);
            }
          }
        }
        if (type === "source") {
          let changeFlag = self.checkSourceChange(
            row.tagSourceSent,
            params.sourceTagFragmentVo
          );
          if (changeFlag === 0) {
            return;
            this.isupdateStatus = 0;
          }
          if (changeFlag === -1) {
            this.$message.error("不允许删除原文标签占位符，请重试");
            Reflect.set(row, "tagSourceSent", row.tagSourceSent);
            return;
          }
        } else if (type === "target") {
          // let data =.parse(row.tagTargetSent).fragments[0].atoms[0].data
          // let fileId = this.getUrlInfo.fileId
          
          if (
            !self.checkTargetChange(this.info, params.targetTagFragmentVo) &&
            !isChange
          ) {
            this.isupdateStatus = 0;
            // console.log('++++++++++');
            return;
          }
        }

        let updataType =
          self.$store.getters["editor/getUpdataFragmentTypeInfo"] || 1;
        let editorBottomActiveNameInfo =
          self.$store.getters["editor/getEditorBottomActiveNameInfo"];
        // 即将插入修改的句子 原本的高亮术语词
        const highlightTerms = {};
        if (row.sourceTermSent && row.sourceTermSent.length) {
          highlightTerms.sourceTermSent = row.sourceTermSent;
        }
        if (row.targetTermSent && row.targetTermSent.length) {
          highlightTerms.targetTermSent = row.targetTermSent;
        }
        let paramsInfo = {};
        Reflect.set(paramsInfo, "params", params);
        Reflect.set(paramsInfo, "type", updataType);
        Reflect.set(paramsInfo, "activeName", editorBottomActiveNameInfo);
        Reflect.set(paramsInfo, "highlightTerms", highlightTerms);
        // console.log(paramsInfo);
        // 调用vuex 更新句子方法
        console.log(paramsInfo, "-----------@@@");
        self.$store
          .dispatch("editor/updateTargetInfo", paramsInfo)
          .then((resp) => {
            if (resp) {
              self.setPreviewInfo(self.getPartIndex);
              // 如果当前文件状态为 未开始 在编辑更新后调用一次 获取任务相关信息方法更新字段finish
              if (entranceType === "task" && this.getTaskDetailNum === 0) {
                self.$store.dispatch("editor/getFileTaskInfo", {
                  id: params.taskId,
                });
                this.getTaskDetailNum += 1;
              }
              if (entranceType === "project" && this.getTaskDetailNum === 0) {
                self.$store.dispatch("editor/projectInfo", { id: projectId });
                this.getTaskDetailNum += 1;
              }
              // 当前更新句段如果原文有一样的内容 为重复锁定句段 则将当前句段更新的译文赋值给重复锁定句段的译文
              this.getList.forEach((item) => {
                if (
                  row.sourceSent === item.sourceSent &&
                  !self.lockState(item)
                ) {
                  item.tagTargetSent = row.tagTargetSent;
                  item.status = row.status;
                }
              });
              if (["task", "school"].includes(entranceType)) {
                // 统计空句子
                let targetparams = {
                  id: params.fileId,
                  taskType: params.taskType,
                  taskId: params.taskId,
                };
                this.$store.dispatch(
                  "editor/countTargetSentIsNull",
                  targetparams
                );
                let data = {};
                Reflect.set(data, "id", params.fileId);
                Reflect.set(data, "fileId", params.fileId);
                Reflect.set(data, "taskId", params.taskId);
                Reflect.set(data, "taskType", params.taskType);
                if (this.getUrlInfo.transModel) {
                  // isClassVersion 是否是班级管理版本 作业进度接口参数
                  Reflect.set(data, "isClassVersion", 1);
                }
                //获取进度
                self.$store.dispatch("editor/getTaskProgress", data);
                self.$store.dispatch("editor/getFileTaskInfo", {
                  id: params.taskId,
                });
              } else {
                this.$store.dispatch("editor/getFileInfo", {
                  id: params.fileId,
                });
              }
              let currentEle = event.target.getAttribute("id");
              if (currentEle) {
                // let currentEleInfo = currentEle.split('-');
                if (self.updataType === "enter") {
                  setTimeout(() => {
                    let contentList = self.getList;
                    let index = contentList.findIndex(item=>item == row)
                    let nextItem = contentList[index + 1];
                     // 如果下一项是被锁定的，则往后查找下一项，直到找到未被锁定的项为止
                    while (nextItem && !this.lockState(nextItem)) {
                      index++;
                      nextItem = contentList[index + 1];
                    }
                    //修改状态完 清除跳转高亮
                    const translatedDom = event.target.parentNode;
                    translatedDom.style.border = "none";
                    translatedDom.style.borderRight = "1px #E5E5E5 solid";
                    // let nextEle = document.getElementById(`${type}-${nextItem.id}`);
                    self.handleEditor(event, nextItem, type, "enter");
                  }, 0);
                } else if (self.updataType === "enterPre") {
                  setTimeout(() => {
                    let contentList = self.getList;
                    let preItem = contentList[index - 1];
                    self.handleEditor(event, preItem, type, "enter");
                  }, 0);
                } else if (self.updataType === "nextNotConfirm") {
                  setTimeout(() => {
                    let contentList = self.getList;
                    let preItem = contentList.find(
                      (item) =>
                        item.status == 0 ||
                        item.status == 1 ||
                        item.status == 2 ||
                        (item.status == 3 && taskType == 2) ||
                        (item.status == 4 && taskType == 3)
                    );
                    if (preItem) {
                      this.isScollerView = true;
                      self.handleEditor(event, preItem, type, "enter");
                    } else {
                      //键盘事件事件
                      this.$message.closeAll();
                      this.$message({
                        message: "当前页以没有未确认句子",
                        type: "warning",
                      });
                    }
                  }, 0);
                }
              }
            }
          })
          .finally(() => {
            self.updataType = "blur";
            self.typeInfo = null;
            self.componentsState = true;
            self.$store.dispatch("editor/setUpdataFragmentType", 1);
          });
        resolve(true);
      }).then(() => {
        self.$nextTick(() => {
          document.getElementById(`${type}-${row.id}`).blur();
        });
        return true;
      });

    },
    //检查原译文是否变更
    checkTargetChange(orgTagSent, updateFragments) {
      console.log(orgTagSent);
      console.log(updateFragments);
      if (
        this.updataType === "enter" ||
        this.updataType === "enterPre" ||
        this.updataType === "nextNotConfirm"
      ) {
        return true;
      } else {
        try {
          if (!orgTagSent) {
            return true;
          }
          if (orgTagSent.content == updateFragments.atoms[0].data) {
            if(orgTagSent.length == 1){
              return false
            }else if(orgTagSent.length > 1){
              return true
            }
          }
          // let targetTag = JSON.parse(orgTagSent);
          // console.log(targetTag)
          // let orgFragments = targetTag.fragments;
          // if (orgTagSent.length !== 1) {
          //   return true;
          // }

          let updateAtoms = updateFragments.atoms;
          // console.log(orgTagSent);
          // console.log(updateAtoms);
          if (updateAtoms.length !== orgTagSent.length) {
            return true;
          }
          for (let i = 0; i < updateAtoms.length; i++) {
            if (orgTagSent.length < i) {
              return true;
            }

            if (updateAtoms[i].data !== orgTagSent[i].data) {
              return true;
            }
          }
          return false;
        } catch (e) {
          return true;
        }
      }
    },
    checkSourceChange(orgTagSent, updateFragments) {
      try {
        if (!orgTagSent) {
          return 1;
        }
        let targetTag = JSON.parse(orgTagSent);
        let orgFragments = targetTag.fragments;
        if (orgFragments.length !== 1) {
          return 1;
        }
        let orgAtoms = orgFragments[0].atoms;
        let updateAtoms = updateFragments.atoms;
        let orgTagNum = 0;
        let updateTagNum = 0;
        updateAtoms.forEach((item) => {
          if (item.dataType === "tag") {
            updateTagNum += 1;
          }
        });
        orgAtoms.forEach((item) => {
          if (item.dataType === "tag") {
            orgTagNum += 1;
          }
        });
        //tag数量不匹配，原文不允许删除tag
        if (orgTagNum !== updateTagNum) {
          return -1;
        }
        if (this.updataType === "enter" || this.updataType === "enterPre") {
          return 1;
        }
        if (updateAtoms.length !== orgAtoms.length) {
          return 1;
        }
        for (let i = 0; i < updateAtoms.length; i++) {
          if (orgAtoms.length < i) {
            return 1;
          }
          if (updateAtoms[i].data !== orgAtoms[i].data) {
            return 1;
          }
        }
        return 0;
      } catch (e) {
        return 1;
      }
    },
    //译文/原文-键盘回车事件
    handleKeyup(e, row, type, index) {
      if (e.key === "Control") {
        this.ctrlPressed = true;
      } else {
        this.ctrlPressed = false;
      }
      if (type === "target" && e.ctrlKey == true && e.keyCode == 90) {
        //Ctrl+Z
        console.log("Ctrl+Z");
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.keyCode = 0;
          e.returnValue = false;
        }
        return;
      }
      this.getStartRange();
      if (type === "source" && e.keyCode !== 13) {
        if (e.keyCode && !this.getisSourceedit) {
          this.$store.dispatch("editor/setSourceeditEditorStatus", false);
          return false;
        } else {
          this.$store.dispatch("editor/setSourceeditEditorStatus", true);
        }
      }
      if (e.keyCode === 13) {
        eventUtil.preventDefault(e);
        //   // 判断当前句子是否处于聚焦状态
        //   const currentEditor = document.activeElement;
        //   console.log(currentEditor);
        //   const targetEditor = document.getElementById(`${type}-${row.id}`);
        //   if (currentEditor !== targetEditor) {
        //     return;
        //   }

        //   // console.log(e.key, "失焦当前内容-选中下一个");
        //   //译文空白的红色边框
        //   let redborderDom = document.getElementsByClassName("redborder")[0];
        //   if (redborderDom) {
        //     redborderDom.style.border = "none";
        //     redborderDom.classList.add("noborder");
        //   }
        //   //译文未确认的红色边框
        //   const dom = document.querySelectorAll(".translated-unsure")[0]?.parentNode?.parentNode?.parentNode;
        //   const styleDom = dom?.childNodes[2];
        //   if (styleDom) {
        //     styleDom.style.border = "none";
        //     styleDom.classList.add("noborder");
        //   }
        //   // eventUtil.preventDefault(e);
        //   if (this.getList.length > index + 1) {
        //     //失焦当前内容-选中下一个
        //     new Promise((resolve) => {
        //       if (type === "target") {
        //         this.updataType = "enter";
        //       }
        //       document.getElementById(`${type}-${row.id}`).blur();
        //       resolve(true);
        //     }).then(() => {
        //       let wrapper = document.querySelector(`#content-${row.id}`);
        //       wrapper.scrollIntoView();
        //       // this.handleEditor(e, (this.getList[index + 1]), type, 'enter');
        //     });
        //   } else {
        //     //键盘事件事件
        //     this.$message.closeAll();
        //     this.$message({
        //       message: "已经是最后一条信息",
        //       type: "warning",
        //     });
        //     this.updataType = "enter";
        //     document.getElementById(`${type}-${row.id}`).blur();
        //   }
      }
    },

    // 滚动事件-触底加载分页数据  改成分页 没有触底 禁用了
    handleScroll: _.debounce(
      function (e) {
        let self = this;
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        let scrollTop = e.target.scrollTop;
        //变量windowHeight是可视区的高度
        let windowHeight = e.target.clientHeight;
        //变量scrollHeight是滚动条的总高度
        let scrollHeight = e.target.scrollHeight;
        //页码
        //滚动条到底部的条件
        if (parseInt(scrollTop + windowHeight + 10) >= scrollHeight) {
          //写后台加载数据的函数
          // console.log("触底加载更多的数据:距顶部" + scrollTop + "可视区高度" + windowHeight + "滚动条总高度" + scrollHeight);
          let domHeight = document.getElementsByClassName("hightLight");
          if (domHeight.length != 0) {
            return false;
          }
          // 如果列表有的条数小于总条数，则继续请求往后加载
          const { type } = this.getUrlInfo;
          if (type === "project") {
            if (
              this.getTaskContentList.transSentRespVoList.length <
              this.getTaskContentList.totalRows
            ) {
              let param =
                this.$store.getters["editor/getTaskContentListParams"];
              if (param.startSort === this.getTaskContentList.totalPage) {
                this.$message.closeAll();
                this.$message.warning("当前已在最后一页");
                return;
              }
              param.startSort++;
              param.urltype = type;
              self.$store.dispatch("editor/continueLoadContent", param);
              this.$nextTick(() => {
                document.getElementById("editorBox").scrollTop = 100;
              });
            }
          } else if (type === "task" || type === "school") {
            if (
              this.getTaskContentList.transSentRespVoList.length <
              this.getTaskContentList.totalRows
            ) {
              let param =
                this.$store.getters["editor/getTaskContentListParams"];
              if (param.startSort === this.getTaskContentList.totalPage) {
                this.$message.closeAll();
                this.$message.warning("当前已在最后一页");
                return;
              }
              param.startSort++;
              param.urltype = type;
              self.$store.dispatch("editor/continueLoadContent", param);
              this.$nextTick(() => {
                document.getElementById("editorBox").scrollTop = 100;
              });
            }
          }
        } else if (scrollTop < 5) {
          const { type } = this.getUrlInfo;
          if (type === "project") {
            let param = this.$store.getters["editor/getTaskContentListParams"];
            if (param.startSort === 1) {
              this.$message.closeAll();
              this.$message.warning("当前已在第一页");
              return;
            }
            param.startSort--;
            param.urltype = type;
            self.$store.dispatch("editor/continueLoadContent", param);
            this.$nextTick(() => {
              document.getElementById("editorBox").scrollTop = 100;
            });
          } else if (type === "task" || type === "school") {
            let param = this.$store.getters["editor/getTaskContentListParams"];
            if (param.startSort === 1) {
              this.$message.closeAll();
              this.$message.warning("当前已在第一页");
              return;
            }
            param.startSort--;
            param.urltype = type;
            self.$store.dispatch("editor/continueLoadContent", param);
            this.$nextTick(() => {
              document.getElementById("editorBox").scrollTop = 100;
            });
          }
        }
      },
      1000,
      {
        leading: true,
      }
    ),

    /**
     * @desc 每一条句子的原文 contenteditable 的状态
     * @return {boolean}
     */
    getSourceEditorState(item, type, data) {
      //项目经理从项目详情进入可以编辑 （项目经理就是项目创建人）
      let isPM = this.getUserInfo.id == this.getProjectInfo.creatorId;
      const { type: myType } = this.getUrlInfo
      if (isPM && myType === 'project') {
        return true;
      }
      if (
        this.getTaskState(item) &&
        this.getTaskState(item).className === "translated-sure"
      ) {
        return false;
      }
      let state = this.lockState(item);
      if (state && this.currentIdType === `${type}-${item.id}`) {
        if (this.currentIdType === `${type}-${item.id}` && type === "source") {
          return this.getSourceeditStatus;
        } else {
          return data;
        }
      } else {
        return false;
      }
    },
    /**
     * @desc 每一条句子的译文 contenteditable 的状态
     * @return {boolean|string}
     */
    getTargetEditorState(item, type, data) {
      //项目经理从项目详情进入可以编辑 （项目经理就是项目创建人）
      let isPM = this.getUserInfo.id == this.getProjectInfo.creatorId;
      const { type: myType } = this.getUrlInfo
      if (isPM && myType === 'project') {
        if (item.operatorName) { //如果有人正在编辑就不允许编辑
          return false
        } else {
          return true
        }
      } else if (myType === 'task') {
        if (item.operatorName) { //如果有人正在编辑就不允许编辑
          return false
        }
      }
      // 判断是否为重复锁定句段
      //如果已确认
      if (
        this.getTaskState(item) &&
        this.getTaskState(item).className === "translated-sure"
      ) {
        //非译审同步可以编辑
        //译审同步的翻译流程不让编辑
        if (this.getProjectInfo.isSyncTransReview == 1 && this.getUrlInfo.taskType == 1) {
          return false;
        } else {
          return true;
        }
      }
      let state = this.lockState(item);
      let userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("msie") === -1) {
        let idInfo = this.$store.getters["editor/getCurrentSentenceIdInfo"];
        if (
          state &&
          Boolean(this.getTargeteditStatus) &&
          idInfo.currentId &&
          idInfo.currentIdType
        ) {
          if (
            idInfo.currentId === `${item.id}` &&
            idInfo.currentIdType === `${type}-${item.id}`
          ) {
            return "true";
          }
        } else {
          return "false";
        }
      } else {
        if (state && !!data) {
          return data;
        } else if (state && this.currentIdType === `${type}-${item.id}`) {
          return "true";
        } else {
          return "false";
        }
      }
    },

    //定义右键
    handleOpenMenu(e) {
      console.log("右键点击了", this.currentItem, this.currentIdType, this.currentId);
      //译审同步翻译流程，已确认 
      if (this.getTaskState(this.currentItem).className === "translated-sure" && this.getProjectInfo.isSyncTransReview == 1 && this.getUrlInfo.taskType == 1 ) {
        return;
      }
      this.selectOldData = window.getSelection().toString();
      if (!!this.currentIdType && !!this.currentId) {
        let params = {
          top: `${e.clientY + 10}px`,
          left: `${e.clientX + 10}px`,
        };
        let showClearTatget = true
        if(this.getTaskState(this.currentItem).className === "translated-sure"){
          showClearTatget = false
        }
        this.mouseInfo = {
          visible: true,
          currentItem: this.currentItem,
          id: this.currentIdType.split("-")[1],
          type: this.currentIdType.split("-")[0],
          selectText: this.selectOldData,
          markType:
            e.target.className &&
              (e.target.className.includes("insert") ||
                e.target.className.includes("del"))
              ? true
              : false,
          data: this.info,
          costTime: Math.floor(this.costTime),
          getFileTaskInfo: this.getFileTaskInfo,
          updataType:
            this.$store.getters["editor/getUpdataFragmentTypeInfo"] || 1,
          editorBottomActiveNameInfo:
            this.$store.getters["editor/getEditorBottomActiveNameInfo"],
            showClearTatget,
        };
        if (this.mouseInfo.markType) {
          this.reviseDom = e.target;
          this.isRevise = true;
        } else {
          this.reviseDom = null;
          this.isRevise = false;
        }

        console.log(this.mouseInfo);
        this.$store.dispatch("editor/setRightMouseInfo", params);
      }
    },
    //鼠标右键点击解锁
    handleOpenLockMenu(e, item) {
      // lockState(item) ? '状态-编辑' : '状态-锁死'
      console.log(this.$route.name == "newEditor" &&
        this.getFileTaskInfo &&
        parseInt(this.getFileTaskInfo.finish) === 1, '@@@');
      if (this.lockState(item)) return
      if (
        this.$route.name == "newEditor" &&
        this.getFileTaskInfo &&
        parseInt(this.getFileTaskInfo.finish) === 1
      )
        return;
      if (
        this.$route.name == "newEditor" &&
        this.getFileTaskInfo &&
        item.contentEditable === 0
      )
        return;
      // if (this.$route.name == "newEditor" && this.getFileTaskInfo && parseInt(this.getFileTaskInfo.finish) === 0 && parseInt(this.getUrlInfo.taskType) !== 3) return
      let params = {
        top: `${e.clientY + 10}px`,
        left: `${e.clientX + 10}px`,
      };
      this.mouseInfo = {
        visible: true,
        currentItem: item,
        type: "lock",
      };
      this.$store.dispatch("editor/setRightMouseInfo", params);
    },
    //鼠标右键关闭事件
    handleCloseMenu() {
      this.mouseInfo = {
        id: null,
        type: null,
        visible: false,
        selectText: null,
        data: [],
      };
      this.isRevise = false;
      this.targetKeyword = "";
      this.sourceKeyword = "";
    },

    //获取批注信息
    handleGetRemarks(item, remarkStatus) {
      const { type } = this.getUrlInfo;
      let fileId = null;
      if (type === "project") {
        fileId = this.getFileInfo.id;
      } else if (type === "task" || type === "school") {
        fileId = this.getFileTaskInfo.fileId;
      }
      //点击获取焦点回去批注信息
      if (this.flagId !== item.id) {
        let sentIdList = Array.of(`${item.id}`);
        this.flagId = item.id;
        let remarksParams = {
          transFileId: fileId,
        };
        Reflect.set(remarksParams, "sentIdList", sentIdList);
        this.$store.dispatch("editor/getCurrentRemarksInfo", remarksParams);
        if (remarkStatus === 1) {
          this.$store.dispatch("editor/setEditorRightActiveName", "second");
        } else {
          this.$store.dispatch("editor/setEditorRightActiveName", "first");
        }
      }
    },

    //批注的弹层
    handleRemarks(item) {
      if (item && !!item.id) {
        this.remarkInfo = {
          sentId: item.id,
          sourceSent: item.sourceSent,
          commentSent: item.sourceSent,
          commentIndex: item.sourceWordNum,
        };
        this.visibleRemarks = true;
        //添加批注切换Tab
        this.$store.dispatch("editor/setEditorRightActiveName", "second");
      }
    },

    //批注的弹层关闭
    handleCancel() {
      this.visibleRemarks = false;
      this.examinationQA = false;
    },

    //鼠标抬起
    handleMouseup(e, item, type, params) {
      this.$nextTick(() => {
        this.getStartRange();
      });
      // this.setTerm(e)
      let oerationSignParams = {};
      if (e.clientX !== this.clientX || e.clientY !== this.clientY) {
        // Reflect.set(
        //   oerationSignParams,
        //   "column",
        //   this.getEditorRightShownInfo.column
        // );
        // if (this.mousedownType === "source") {
        //   // console.log('原文');
        //   this.targetKeyword = "";
        //   this.sourceKeyword = window.getSelection().toString();
        //   Reflect.set(oerationSignParams, "sourceKeyword", this.sourceKeyword);
        //   Reflect.set(oerationSignParams, "targetKeyword", this.targetKeyword);
        //   this.$store.dispatch(
        //     "editor/setOerationSignInfo",
        //     oerationSignParams
        //   );
        // } else if (this.mousedownType === "target") {
        //   // console.log('译文');
        //   this.targetKeyword = window.getSelection().toString();
        //   Reflect.set(
        //     oerationSignParams,
        //     "sourceKeyword",
        //     this.sourceKeyword || this.selectOldData
        //   );
        //   Reflect.set(oerationSignParams, "targetKeyword", this.targetKeyword);
        //   console.log('22222222222222');
        //   this.$store.dispatch(
        //     "editor/setOerationSignInfo",
        //     oerationSignParams
        //   );
        // }
      } else {
        Reflect.set(oerationSignParams, "column", "third");
        Reflect.set(oerationSignParams, "keyword", null);
        this.$store.dispatch("editor/setOerationSignInfo", oerationSignParams);
      }
      //或者是项目经理从项目进入）
      let isPM = this.getUserInfo.id == this.getProjectInfo.creatorId;
      const { type: myType } = this.getUrlInfo
      if (this.lockState(item) || isPM && myType === 'project') {
        if (e.target.getAttribute("termid")) {
          this.$message.warning(
            "当前元素为术语内容,不允许对该类型内容进行操作"
          );
          return false;
        }
        this.handleGetRemarks(item);
        //   if (item && !!(item.id)) {
        //     console.log(item.id)
        //   this.remarkInfo = {
        //     sentId: (item.id),
        //     sourceSent: (item.sourceSent),
        //     commentSent: (item.sourceSent),
        //     commentIndex: (item.sourceWordNum)
        //   };
        //   // this.visibleRemarks = true;
        //   //添加批注切换Tab
        //   // this.$store.dispatch('editor/setEditorRightActiveName', 'second');
        // }
        let Array1 = Array();
        let Array2 = Array();
        let stringPre = "";
        let stringSuf = "";
        let state = false;
        let enevt = params || e.target;
        let selection = window.getSelection();
        if (selection.type !== "None") {
          const ele = selection.getRangeAt(0);
          if (
            !!ele &&
            !!ele.commonAncestorContainer &&
            !!ele.commonAncestorContainer.parentNode &&
            !!ele.commonAncestorContainer.parentNode.getAttribute("class")
          ) {
            let info =
              ele.commonAncestorContainer.parentNode.getAttribute("class");
            let info2 = enevt.getAttribute("info");
            //判断原数据字段必须存在
            if (item.tagSourceSent) {
              let currentInfo = JSON.parse(item.tagSourceSent);
              if (
                !!currentInfo.fragments &&
                currentInfo.fragments[0] &&
                Reflect.has(currentInfo.fragments[0], "atoms")
              ) {
                let params = Array();
                //拆分句对的前半句
                let paramsPre = Object();
                //拆分句子的后半句
                let paramsSuf = Object();
                if (info) {
                  let infoArr = info.split(" ");
                  let infoArr2 = info2 && info2.split("*");
                  this.$nextTick(() => {
                    let childrenNodeAll = e.currentTarget.childNodes;
                    let TextNodes2 = domArray2(childrenNodeAll, Array());
                    let findId = 0;
                    if (!!infoArr && !!infoArr[6]) {
                      findId = infoArr[6];
                    } else if (infoArr2 && infoArr2[6]) {
                      findId = infoArr2[6];
                    }
                    if (findId === 0) {
                      let targetNode = null;
                      if (ele.commonAncestorContainer === e.target) {
                        let sIndex = 0;
                        let childNodes = e.target.childNodes;
                        if (e.target.nodeName === "DIV") {
                          targetNode =
                            childNodes[
                            ele.endOffset === childNodes.length
                              ? ele.endOffset - 1
                              : ele.endOffset
                            ];
                        } else {
                          for (let idx = 0; idx < childNodes.length; idx++) {
                            let node = childNodes[idx];
                            let len = 0;
                            if (node.nodeType === 3) {
                              len = node.nodeValue.length;
                            } else {
                              len = node.innerText.length;
                            }
                            // console.log(ele.endOffset, idx, sIndex, len, node);

                            if (ele.endOffset <= idx + sIndex + len) {
                              targetNode = node;
                              break;
                            }
                            sIndex += len;
                          }
                        }
                      } else {
                        targetNode = ele.commonAncestorContainer.parentNode;
                      }
                      if (targetNode && targetNode.getAttribute("info")) {
                        infoArr2 = targetNode.getAttribute("info").split("*");
                        if (infoArr2 && infoArr2[6]) {
                          findId = infoArr2[6];
                        }
                      }
                    }
                    TextNodes2.forEach((item, index) => {
                      if (ele.commonAncestorContainer.nodeValue) {
                        let dataHTML =
                          item.data === undefined
                            ? item.data
                            : item.data.toString().replace(/<[^>]+>/g, "");
                        Reflect.set(item, "data", dataHTML);
                        // console.log(item);
                        // if ((findId === item.fid)) {
                        // console.log(item,"item");
                        if (
                          ele.commonAncestorContainer.nodeValue === item.data
                        ) {
                          let start = item.data.substr(0, ele.endOffset);
                          let end = item.data.substr(ele.endOffset);
                          state = true;
                          if (start) {
                            let paramsStart = { ...item };
                            Reflect.set(paramsStart, "data", start);
                            Array1.push(paramsStart);
                            stringPre = `${stringPre}${start}`;
                          }
                          if (end) {
                            let paramsEnd = { ...item };
                            Reflect.set(paramsEnd, "data", end);
                            Array2.push(paramsEnd);
                            stringSuf = `${stringSuf}${end}`;
                          }
                          // }
                        } else {
                          // console.log(item,"结尾item");
                          if (!state) {
                            Array1.push(item);
                            if (item.dataType !== "tag" && !!item.data) {
                              stringPre = `${stringPre}${item.data}`;
                            }
                          } else {
                            Array2.push(item);
                            if (item.dataType !== "tag" && !!item.data) {
                              stringSuf = `${stringSuf}${item.data}`;
                            }
                          }
                        }
                      } else {
                        // console.log(findId, item, ele.endOffset, TextNodes2.length, 'ele');
                        // 判断当前光标偏移是奇数/偶数
                        // console.log(findId, item, index, TextNodes2.length - 1, '-----');
                        // && index !== TextNodes2.length - 1
                        if (
                          findId === item.fid &&
                          ele.endOffset !== TextNodes2.length
                        ) {
                          state = true;
                        }
                        if (!state) {
                          let paramsStart = { ...item };
                          Array1.push(paramsStart);
                          if (item.dataType !== "tag" && !!item.data) {
                            stringPre = `${stringPre}${item.data}`;
                          }
                        } else {
                          let paramsEnd = { ...item };
                          Array2.push(paramsEnd);
                          if (item.dataType !== "tag" && !!item.data) {
                            stringSuf = `${stringSuf}${item.data}`;
                          }
                        }
                      }
                    });
                    let tempPre = Object();
                    //返回atoms字段的数据--拼接对象
                    Reflect.set(tempPre, "atoms", Array1);
                    Reflect.set(tempPre, "sort", currentInfo.sort);
                    Reflect.set(tempPre, "text", stringPre);
                    Reflect.set(tempPre, "type", currentInfo.type);
                    Reflect.set(paramsPre, "sourceSent", stringPre);
                    Reflect.set(paramsPre, "tagSourceSent", tempPre);
                    let tempSuf = Object();
                    Reflect.set(tempSuf, "atoms", Array2);
                    Reflect.set(tempSuf, "sort", currentInfo.sort);
                    Reflect.set(tempSuf, "text", stringSuf);
                    Reflect.set(tempSuf, "type", currentInfo.type);
                    Reflect.set(paramsSuf, "sourceSent", stringSuf);
                    Reflect.set(paramsSuf, "tagSourceSent", tempSuf);

                    // console.log(tempPre, 'tempPre');
                    // console.log(tempSuf, 'tempSuf');
                    // console.log(stringPre, 'stringPre');
                    // console.log(stringSuf, 'stringSuf');
                    //合成前后句
                    params.push(paramsPre);
                    params.push(paramsSuf);
                    if (stringPre && stringSuf) {
                      // console.log('middle');
                      params.push("middle");
                    } else if (stringPre && !stringSuf) {
                      // console.log('tail');
                      params.push("tail");
                    } else if (!stringPre && stringSuf) {
                      // console.log('header');
                      params.push("header");
                    }
                    // console.log(params, "------------")
                    //光标所在的文本域内容为空或者光标落在最后
                    if (type === "source") {
                      if (!!Array1.length && !!Array2.length) {
                        this.$store.dispatch(
                          "editor/recordCursorPosition",
                          params
                        );
                        this.$store.dispatch("editor/setUpdataFragmentType", 4);
                      }
                    } else if (type === "target") {
                      // console.log(params, "44444");
                      this.$store.dispatch(
                        "editor/recordCursorPositionTarget",
                        params
                      );
                    }
                  });
                } else {
                  if (type === "target") {
                    let childrenNodeAll = e.currentTarget.childNodes;
                    let TextNodes2 = domArray2(childrenNodeAll, Array());
                    TextNodes2.forEach((item) => {
                      if (item.data) {
                        stringPre = `${stringPre}${item.data}`;
                      }
                    });
                    let tempPre = Object();
                    //返回atoms字段的数据--拼接对象
                    Reflect.set(tempPre, "atoms", TextNodes2);
                    Reflect.set(tempPre, "sort", currentInfo.sort);
                    Reflect.set(tempPre, "text", null);
                    Reflect.set(tempPre, "type", currentInfo.type);
                    Reflect.set(paramsPre, "sourceSent", null);
                    Reflect.set(paramsPre, "tagSourceSent", tempPre);
                    let tempSuf = Object();
                    Reflect.set(tempSuf, "atoms", Array2);
                    Reflect.set(tempSuf, "sort", currentInfo.sort);
                    Reflect.set(tempSuf, "text", stringPre);
                    Reflect.set(tempSuf, "type", currentInfo.type);
                    Reflect.set(paramsSuf, "sourceSent", stringPre);
                    Reflect.set(paramsSuf, "tagSourceSent", tempPre);
                    params.push(paramsPre);
                    params.push(paramsSuf);
                    params.push("tail");

                    this.$store.dispatch(
                      "editor/recordCursorPositionTarget",
                      params
                    );
                    //备注
                  }
                }
              }
            }
          }
        }
      }
    },
    //术语划词
    setTerm(e) {
      if(this.mousedownType){
        // if ((this.getEditorRightShownInfo.column) === 'second') return
        let oerationSignParams = {};
        if (e.clientX !== this.clientX || e.clientY !== this.clientY) {
          Reflect.set(
            oerationSignParams,
            "column",
            this.getEditorRightShownInfo.column
          );
          if (this.mousedownType === "source") {
            // console.log('原文');
            this.targetKeyword = "";
            this.sourceKeyword = window.getSelection().toString();
            Reflect.set(oerationSignParams, "sourceKeyword", this.sourceKeyword);
            Reflect.set(oerationSignParams, "targetKeyword", this.targetKeyword);
            this.$store.dispatch(
              "editor/setOerationSignInfo",
              oerationSignParams
            );
          } else if (this.mousedownType === "target") {
            // console.log('译文');
            this.targetKeyword = window.getSelection().toString();
            Reflect.set(
              oerationSignParams,
              "sourceKeyword",
              this.sourceKeyword 
            );
            Reflect.set(oerationSignParams, "targetKeyword", this.targetKeyword);
            this.$store.dispatch(
              "editor/setOerationSignInfo",
              oerationSignParams
            );
          }
        }
        this.mousedownType = ''
      }
    },

    //原文键盘事件
    handleMouseupSource(e, item, type) {
      const ele = window.getSelection();
      let info = ele.anchorNode.parentNode;
      // console.log(info);
      // console.log(this.startRange);
      // console.log(this.range);

      info && this.handleMouseup(e, item, type, info);
    },

    //键盘事件
    handleKeyupSource(e, item, index, type) {
      if (e.key === "Control" && this.ctrlPressed) {
        console.log(e.key, "失焦当前内容-选中下一个");
        const {taskType} =this.getUrlInfo
        //如果译文为空提示
        let targetItemDom = document.getElementById(`target-${item.id}`);
        let domText = targetItemDom ? targetItemDom.innerText.replace(/\s+/g, "") : null;
        if (!domText) {
          this.$message.warning("译文为空,不可确认句子");
        }
        //译文空白的红色边框
        let redborderDom = document.getElementsByClassName("redborder")[0];
        if (redborderDom) {
          redborderDom.style.border = "none";
          redborderDom.classList.add("noborder");
        }
        //译文未确认的红色边框
        const dom = document.querySelectorAll(".translated-unsure")[0].parentNode.parentNode.parentNode;
        const styleDom = dom.childNodes[2];
        if (styleDom) {
          styleDom.style.border = "none";
          styleDom.classList.add("noborder");
        }
        eventUtil.preventDefault(e);
        if (
          this.getList.find(
            (item) => item.status == 0 || item.status == 1 || item.status == 2 ||(item.status == 3 && taskType == 2) || (item.status == 4 && taskType == 3)
          ) != undefined
        ) {
          //失焦当前内容-选中下一个
          new Promise((resolve) => {
            if (type === "target") {
              this.updataType = "nextNotConfirm";
            }
            document.getElementById(`${type}-${item.id}`).blur();
            resolve(true);
          })
        } else {
          //键盘事件事件
          this.$message.closeAll();
          this.$message({
            message: "当前页以没有未确认句子",
            type: "warning",
          });
          this.updataType = "nextNotConfirm";
          document.getElementById(`${type}-${item.id}`).blur();
        }
      }
      if (e.keyCode === 13) {
        eventUtil.preventDefault(e);
        // if(!this.enterFoucs) return
        // 判断当前句子是否处于聚焦状态
        const currentEditor = document.activeElement;
        console.log('回车抬起');
        const targetEditor = document.getElementById(`${type}-${item.id}`);
        if (currentEditor !== targetEditor) {
          return;
        }

        // console.log(e.key, "失焦当前内容-选中下一个");
        //译文空白的红色边框
        let redborderDom = document.getElementsByClassName("redborder")[0];
        if (redborderDom) {
          redborderDom.style.border = "none";
          redborderDom.classList.add("noborder");
        }
        //译文未确认的红色边框
        const dom = document.querySelectorAll(".translated-unsure")[0]?.parentNode?.parentNode?.parentNode;
        const styleDom = dom?.childNodes[2];
        if (styleDom) {
          styleDom.style.border = "none";
          styleDom.classList.add("noborder");
        }
        // eventUtil.preventDefault(e);
        if (this.getList.length > index + 1) {
          //失焦当前内容-选中下一个
          new Promise((resolve) => {
            if (type === "target") {
              this.updataType = "enter";
            }
            document.getElementById(`${type}-${item.id}`).blur();
            // this.enterFoucs = false
            resolve(true);
          }).then(() => {
            let wrapper = document.querySelector(`#content-${item.id}`);
            wrapper.scrollIntoView();
            // this.handleEditor(e, (this.getList[index + 1]), type, 'enter');
          });
        } else {
          //键盘事件事件
          this.$message.closeAll();
          this.$message({
            message: "已经是最后一条信息",
            type: "warning",
          });
          this.updataType = "enter";
          document.getElementById(`${type}-${item.id}`).blur();
        }
      }
      // (Ctrl+箭头上)
      if (e.ctrlKey && e.keyCode === 38) {
        this.updataType = "enterPre";
        eventUtil.preventDefault(e);
        let contentList = this.getList;
        if (!!contentList.length && !!e.target.id) {
          let EleId = e.target.id;
          let EleIdArr = EleId.split("-");
          if (EleIdArr.length) {
            let id = EleIdArr[1];
            contentList.every((item, index) => {
              if (parseInt(item.id) === parseInt(id)) {
                if (index === 0) {
                  //键盘事件事件
                  this.$message.warning("已经是第一条信息");
                  this.updataType = "enter";
                  document.getElementById(`${type}-${item.id}`).blur();
                } else {
                  new Promise((resolve) => {
                    if (type === "source") {
                      this.updataType = "enter";
                    }
                    //当前句子 失去焦点
                    document.getElementById(`${type}-${item.id}`).blur();
                    resolve(true);
                  }).then(() => {
                    //上一句获取焦点
                    this.updataType = "enterPre";
                  });
                  return false;
                }
              } else {
                this.updataType = "enterPre";
                document.getElementById(`${type}-${item.id}`).blur();
                return true;
              }
            });
          }
        }
      } else {
        switch (e.keyCode) {
          case 37:
            this.handleMouseupSource(e, item, type);
            console.log("左键");
            break;
          case 38:
            this.handleMouseupSource(e, item, type);
            console.log("上键");
            break;
          case 39:
            this.handleMouseupSource(e, item, type);
            console.log("右键");
            break;
          case 40:
            this.handleMouseupSource(e, item, type);
            console.log("下键");
            break;
          case 8:
          case 46:
            this.handleMouseupSource(e, item, type);
            console.log("删除键");
            break;
          default:
            this.handleMouseupSource(e, item, type);
            break;
        }
      }
    },

    //获取tag的属性信息
    getInfo(row, type) {
      let infos;
      let SentInfo;
      if (type === "source" && !!row.tagSourceSent) {
        SentInfo = JSON.parse(row.tagSourceSent);
      }
      if (type === "target" && !!row.tagTargetSent) {
        SentInfo = JSON.parse(row.tagTargetSent);
      } else {
        SentInfo = JSON.parse(row.tagSourceSent);
      }
      if (SentInfo) {
        let SentInfos = SentInfo.fragments[0].atoms || [];
        let newSentInfos = SentInfos.filter((item) => item.dataType === "text");
        if (newSentInfos.length) {
          infos = `${newSentInfos[0].atomKey || row.templateKey}*${newSentInfos[0].dataType || "text"
            }*${newSentInfos[0].id || row.id}*${newSentInfos[0].sort ||
            `${parseInt(row.id.toString().substr(0, 5))}`
            }*${newSentInfos[0].style || "style"}*${newSentInfos[0].tagType || "text"
            }`;
        } else {
          infos = `${row.templateKey}*${"text"}*${row.id}*${`${parseInt(
            row.id.toString().substr(0, 5)
          )}`}*${"style"}*${"text"}`;
        }
        return infos;
      }
    },

    //更新句子状态
    handleUpdataState(item) {
      console.log("修改状态");
      let params = {};
      let dom = document.getElementById(`target-${item.id}`);
      let domText = dom ? dom.innerText.replace(/\s+/g, "") : null;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        let target = JSON.parse(item.tagTargetSent);
        if (!!target.fragments[0].atoms[0].data || !!domText) {
          const { type, taskType, projectId, taskId, fileId } = this.getUrlInfo;
          if (parseInt(taskType)) {
            Reflect.set(params, "sentId", item.id);
            Reflect.set(params, "projectId", projectId);
            Reflect.set(params, "taskType", taskType);
            Reflect.set(params, "taskId", taskId);
            Reflect.set(params, "fileId", fileId);
            Reflect.set(params, "isUpdateTargetSent", this.isChangeModifyingRecords);
            // Reflect.set(params, "isUpdateTargetSent", this.isupdateStatus);
            this.$store.dispatch("editor/fragmentQAInfo", params);
            if (
              this.getTaskState(item).title === "翻译已确认" ||
              this.getTaskState(item).title === "审校已确认" ||
              this.getTaskState(item).title === "复审已确认"
            ) {
              let params = Object();
              Reflect.set(params, "projectId", projectId);
              Reflect.set(params, "sentId", item.id);
              Reflect.set(params, "taskType", taskType);
              Reflect.set(params, "fileId", fileId);
              Reflect.set(params, "taskId", taskId);
              //取消确认(编辑器取消打勾)
              this.$store.dispatch("editor/cancelConfirmation", params);
            } else {
              this.$store.dispatch("editor/updataSentStatus", params);
            }
            // 任务进度
            let taskProgressParams = {};
            Reflect.set(taskProgressParams, "id", fileId);
            Reflect.set(taskProgressParams, "fileId", fileId);
            Reflect.set(taskProgressParams, "taskId", taskId);
            Reflect.set(taskProgressParams, "taskType", taskType);
            if (this.getUrlInfo.transModel) {
              // isClassVersion 是否是班级管理版本 作业进度接口参数
              Reflect.set(taskProgressParams, "isClassVersion", 1);
            }
            this.$store.dispatch("editor/getTaskProgress", taskProgressParams);
            this.isupdateStatus = 0;
            //译文未确认的红色边框
            const dom =
              document.querySelectorAll(".translated-unsure")[0].parentNode
                .parentNode.parentNode;
            const styleDom = dom.childNodes[2];
            styleDom.style.border = "none";
            styleDom.style.borderRight = "1px #E5E5E5 solid";
          } else {
            this.$message.warning("译文为空,或者句子已经确认");
            this.isupdateStatus = 0;
          }
        } else {
          this.$message.warning("译文为空,不可确认句子");
          this.isupdateStatus = 0;
        }
      }, 0);
    },

    /**
     * @desc 判断当前句段是否是锁定
     * @return {boolean}
     */
    lockState(item) {
      const { type } = this.getUrlInfo;
      //可读可写的状态 - 1/0
      // ifOnlyPreview:0  是否只能预览：0.不是 1.是
      let ifOnlyPreview = !(
        parseInt(this.getTaskContentList.ifOnlyPreview) === 1
      );
      if (item) {
        //文件内重复- sameFileSentNo > 0    锁定/不锁定
        let fileSome = parseInt(item.sameFileSentNo) === 0;
        //项目内重复- sameProjectSentNo > 0 锁定/不锁定
        let projectSome = parseInt(item.sameProjectSentNo) === 0;
        let isFinish = ["task", "school"].includes(type) && parseInt(this.getFileTaskInfo.finish) !== 1;
        if (type === "project") {
          //项目进入 两种情况会上锁 1.句子重复的 2.已经分配的
          //而项目经理只用判断是否重复
          // 项目判断是否为拆分
          //是否被拆分 0/1 - (未分配/分配) - (能编辑/编辑)
          let isPM = this.getUserInfo.id == this.getProjectInfo.creatorId; //项目经理
          let isSplit = !parseInt(this.getFileInfo.isSplit);
          if (isPM) {
            return projectSome && fileSome
          } else {
            return isSplit && projectSome && fileSome
          }
        } else if (type === "school") {
          let islock = this.getUserInfo.id === this.getProjectInfo.pmUserId;
          return islock
            ? ifOnlyPreview && projectSome && fileSome
            : isFinish && ifOnlyPreview && projectSome && fileSome;
        } else if (type === "task") {
          // contentEditable 0锁住 1不锁住 
          const isContenteditable = item.contentEditable === 1;
          return isFinish && isContenteditable && projectSome && fileSome;
        }
      }
    },

    /**
     * @desc 机翻图标
     * @return {string}
     */
    getMachineTranslatedState(item) {
      let isLock = this.lockState(item);
      // console.log(item, '@@@@@@@@$');
      if (isLock) {
        switch (item.mtStatus) {
          case 0:
            return "machine_translation_failed";
          case 1:
            return "machine_translate";
          default:
            return "machine_translate";
        }
      }
    },

    /**
     * @desc 获取当前句子的状态
     * @return {object} params 返回html标签 title属性内容及 className对应类名
     */
    getTaskState(item) {
      let isLock = this.lockState(item);
      let params = {};
      if (isLock) {
        const taskType = parseInt(this.getUrlInfo.taskType);
        const sentenceStatus = parseInt(item.status);
        if (taskType === 1) {
          //翻译
          if (sentenceStatus === 3) {
            // if (sentenceStatus === 3 && this.getProjectInfo.isSyncTransReview === 1) {
            Reflect.set(params, "title", "翻译已确认");
            Reflect.set(params, "className", "translated-sure");
            return params;
          } else {
            Reflect.set(params, "title", "翻译未确认");
            Reflect.set(params, "className", "translated-unsure");
            return params;
          }
        } else if (taskType === 2) {
          //审校
          if (sentenceStatus === 4) {
            Reflect.set(params, "title", "审校已确认");
            Reflect.set(params, "className", "translated-sure");
            return params;
          } else {
            Reflect.set(params, "title", "审校未确认");
            Reflect.set(params, "className", "translated-unsure");
            return params;
          }
        } else if (taskType === 3) {
          //复审
          if (sentenceStatus === 5) {
            Reflect.set(params, "title", "复审已确认");
            Reflect.set(params, "className", "translated-sure");
            return params;
          } else {
            Reflect.set(params, "title", "复审未确认");
            Reflect.set(params, "className", "translated-unsure");
            return params;
          }
        }
      } else {
        Reflect.set(params, "title", "句子已锁死");
        Reflect.set(params, "className", "locking");
        return params;
      }
    },

    // //获取单句的状态
    // getState (item) {
    //   let isLock = this.lockState(item);
    //   if (isLock) {
    //     switch ((item.status)) {
    //       case 0:
    //         // console.log('未翻译');
    //         return 'un-translated';
    //       case 1:
    //         // console.log('机器翻译');
    //         return 'machine-translated';
    //       case 2:
    //         // console.log('已编辑未确认');
    //         return 'translated-unsure';
    //       case 3:
    //         // console.log('已编辑已确认');
    //         return 'translated-sure';
    //       case 4:
    //         // console.log('已审校已确认');
    //         return 'proofread-sure';
    //       case 5:
    //         // console.log('已复审已确认');
    //         return 'last-proofread-sure';
    //       default:
    //       // console.log('未知');
    //     }
    //   } else {
    //     return 'locking'
    //   }
    // },
    //检查浏览器
    checkBrowser() {
      let userAgent = window.navigator.userAgent.toLowerCase();
      if (
        userAgent.indexOf("firefox") !== -1 ||
        userAgent.indexOf("msie") !== -1 ||
        userAgent.indexOf("trident") !== -1
      ) {
        this.contentEditableValue = "true";
      }
    },
  },
};
</script>

<style lang="less" scoped="true">
@import "./assets/style.less";
</style>
<style scoped lang="less">
.df {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;

  .correct-item {
    position: absolute;
  }
}

.qa-popover {
  height: 50%;

  /deep/.el-popover__reference-wrapper {
    display: block;
    height: 100%;

    .el-button {
      padding: 0;
      border: none;
      background-color: transparent;
      color: #606266 !important;
      display: block;
      height: 100%;
      width: 100%;

      .QA-error {
        height: 100% !important;
      }
    }
  }
}
</style>
<style lang="less" >
.custom-popover-style {
  background-color: #303133;
  color: #fff;

  .popper__arrow::after {
    border-right-color: #303133 !important;
  }

  .qa-item {
    padding-left: 20px;
    background: url(./assets/images/tips.png) no-repeat left center;
  }
}
</style>
